//Import Geral
import axios from "axios";
import Globais, {
  validateToken,
  logout,
  validaCPF,
  validacaoEmail,
  validaRg,
} from "../../components/Globais";

import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { NumberParam, useQueryParams } from "use-query-params";
import { useNavigate } from "react-router-dom";

//Import Material UI - Steps

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import SettingsIcon from "@mui/icons-material/Settings";

//Import Ant-Design
import {
  Button as ButtonForm,
  Card,
  Checkbox,
  CheckboxProps,
  Col,
  Divider,
  Flex,
  Form,
  GetProp,
  Input,
  InputNumber,
  List,
  message,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Skeleton,
  Space,
  Typography as TypographyAntd,
  Upload,
  UploadFile,
} from "antd";

import MaskedInput from "antd-mask-input";
import { ConsoleSqlOutlined, UploadOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";
import {
  verificarSeTemPeriodoUsuario,
  verificarSeTemPeriodoUsuarioDefinido,
} from "../../uteis/periodoUsuario/Globais";
import {
  atualizarCotaUsuarioGlobais,
  buscarStatusCTU,
  regularizarSituacaoCTU,
  verificarCTUChecada,
  verificarPagamentoPorStatus,
  verificarSeMaisInformacoesAnuncioEstaoAusentes,
  verificarSeTemArquivos,
} from "../../uteis/cotaUsuario/Globais";
import warning from "antd/es/_util/warning";
import {
  buscarAssinaturaPorCotaUsuario,
  criarAssinaturaCTU,
} from "../../uteis/assinatura/Globais";
import { buscarTodosOsRepresentantesCotaUsuario } from "../../uteis/representante/Globais";
import { atualizarUsuarioGlobais } from "../../uteis/usuario/Globais";
import { isHideMenuKey } from "@mui/x-data-grid/utils/keyboardUtils";
import { atualizarApartamento } from "../../uteis/apartamento/Globais";
import PhoneInput from "react-phone-input-2";
import { numberPadrao } from "../../uteis/formatPhoneNumber";

//Styled-Components
const ContainerButton = styled.div`
  margin-top: -2%;
  @media (min-width: 200px) and (max-width: 430px) {
    margin-top: -10%;
  }
`;

const CardTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  text-wrap: wrap;
  @media (min-width: 200px) and (max-width: 430px) {
    font-size: 1rem;
  }
  @media (min-width: 431px) and (max-width: 820px) {
    font-size: 1.8rem;
  }
  @media (min-width: 821px) and (max-width: 1025px) {
    font-size: 2.2rem;
  }
`;

const StyledTitle = styled.h1`
  font-size: 2rem; /* Tamanho padrão para dispositivos maiores */

  /* Media query para dispositivos móveis */
  @media (max-width: 600px) {
    font-size: 1.5rem; /* Tamanho da fonte para dispositivos móveis */
  }

  /* Estilos adicionais, se necessário */
  text-align: center; /* Centraliza o texto */
  color: #000; /* Cor do texto */
  margin: 16px 0; /* Margem superior e inferior */
`;

export default function ViewCadastroPropriedade() {
  // --------------- Constantes --------------------
  const steps = [
    "Cadastro inicial",
    "Validação de proprietário",
    "Configuração de propriedade",
    "Anúncio de venda",
    "Finalizando",
  ]; //Array de steps, caso queria adicionar mais steps, só incluir dentro do array

  const { Title } = TypographyAntd;

  const navigate = useNavigate();

  const layout = {
    //Layout que altera o tamanho e a posição dos nomes e labels dos formulários de : Empreendimentos,Especificações de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
  };
  const layoutAp = {
    //Layout que altera o tamanho e a posição dos nomes e labels do formulário: Mais Info do Apartamento
    labelCol: { span: 16 },
    wrapperCol: { span: 8 },
  };

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
    types: {
      email: "${label} não é válido!",
      number: "${label} não é um número!",
    },
  };
  /* eslint-enable no-template-curly-in-string */

  const estadoCivilOpcoes = [
    //Array de Opções usadas no SELECT de atualizar cadastro e cadastrar proprietario
    { id: 1, label: "Solteiro", value: "SOLTEIRO" },
    { id: 2, label: "Casado", value: "CASADO" },
    { id: 3, label: "Separado", value: "SEPARADO" },
    { id: 4, label: "Divorciado", value: "DIVORCIADO" },
    { id: 5, label: "Viúvo", value: "VIUVO" },
  ];
  const estadoCivil: EstadoCivil[] = estadoCivilOpcoes.map((ec) => ({
    // Map do array
    id: ec.id,
    label: ec.label,
    value: ec.value,
  }));

  const vistaOptions = [
    //Array de Opções usadas no SELECT de cadastrar apartamento
    { label: "Não Sei", value: "NAO_SEI" },
    { label: "Estacionamento", value: "ESTACIONAMENTO" },
    { label: "Mar", value: "MAR" },
    { label: "Montanha", value: "MONTANHA" },

    { label: "Piscina", value: "PISCINA" },
  ];

  const diasDaSemana = [
    //Array de Opções usadas no SELECT de dias da semana
    { id: 1, label: "Segunda-Feira", value: "SEGUNDA" },
    { id: 2, label: "Terça-Feira", value: "TERCA" },
    { id: 3, label: "Quarta-Feira", value: "QUARTA" },
    { id: 4, label: "Quinta-Feira", value: "QUINTA" },
    { id: 5, label: "Sexta-Feira", value: "SEXTA" },
    { id: 6, label: "Sábado", value: "SABADO" },
    { id: 7, label: "Domingo", value: "DOMINGO" },
  ];

  const situacaoPropriedade = [
    //Array de Opções usadas no SELECT de dias da semana
    { id: 1, label: "Escriturado", value: "ESCRITURADO" },
    { id: 2, label: "Quitado", value: "QUITADO" },
    { id: 3, label: "Não Quitado", value: "NAO_QUITADO" },
    { id: 4, label: "Na planta", value: "NA_PLANTA" },
  ];

  //----------------  Interfaces --------------------
  interface Estado {
    id: number;
    nome: string;
    abreviacao: string;
    origem: number;
  }

  interface Cidade {
    id: number;
    nome: string;
    estadoId: number;
  }

  interface EstadoCivil {
    id: number;
    label: string;
    value: string;
  }

  interface Pais {
    id: number;
    nome: string;
    abreviacao: string;
    origem: number;
  }
  interface Usuario {
    nome?: string;
    sobrenome?: string;
    email?: string;
    cpf?: string;
    rg?: string;
    celular?: string;
    estadoCivil?: string;
    nacionalidade?: string;
  }
  interface ApData {
    banheiros: number;
    capacidade: number;
    created_at: string;
    empreendId: number;
    estacionamento: number;
    id: number;
    metragem: number;
    nome: string;
    origem: number;
    quartos: number;
    terreo: number;
    updated_at: string;
    varanda: number;
  }
  interface Empreendimento {
    id?: number;
    cidadeId?: number;
    estado?: number;
    nome?: string;
    pais?: number;
    origem?: number;
    cronograma?: number;
  }
  interface Empreendimentos {
    id: number;
    cidadeId: number;
    estado: number;
    nome: string;
    pais: number;
    origem: number;
    created_at: Date;
  }

  interface Apartamento {
    id?: number;
    empreendId?: number;
    nome?: string;
    capacidade?: number;
    quartos?: number;
    banheiros?: number;
    metragem?: number;
    varanda?: number;
    terreo?: number;
    vista?: number;
    estacionamento?: number;
    origem?: number;
  }
  interface MaisInfoAp {
    cotaId?: number;
    usuarioId?: number;
    status?: string;
    andar?: number;
    bloco?: string;
    numeroApto?: string;
    vista?: string;
  }

  interface Cadastro {
    usuarioId?: number;
    nome?: string;
    sobrenome?: string;
    email?: string;
    cpf?: string;
    rg?: string;
    celular?: string;
    nacionalidade?: string;
    paisId?: number;
    estadoCivil?: string;
    endereco?: string;
    complemento?: string;
    estadoId?: number;
    cidadeId?: number;
  }
  interface Cotas {
    id: number;
    aptoId: number;
    origem: number;
    numeroCota: number;
    semanasPorAno: number;
    diaInicio: number;
  }
  interface CotaUsuario {
    id: number;
    cotaId: number;
    usuarioId: number;
    status: string;
    prioridade: string;
    saldoDevedor: number;
    valorCondominio: number;
    valorVenda: number;
    situacao: string;
  }
  //----------------  Hooks e Variáveis de Estado --------------------
  const isLoading = useRef(false);
  const status = useRef("");

  const [bloquearBotaoProximo, setBloquearBotaoProximo] = useState(true);
  const [propriedadeTemPeriodos, setPropriedadeTemPeriodos] = useState("Não");
  const [propriedadeTemPeriodosDefinidos, setPropriedadeTemPeriodosDefinidos] =
    useState("Não");
  const [pagamentoRegularizado, setPagamentoRegularizado] = useState("Não");
  const [representanteRegularizado, setRepresentanteRegularizado] =
    useState("Não");
  const [propriedadeAutenticada, setPropriedadeAutenticada] = useState("Não");
  const [textoFinalizacao, setTextoFinalizacao] = useState("");
  const [numeroCota, setNumeroCota] = useState("");
  const [openSucess, setOpenSucess] = useState(false);
  const [cpfEmailBloqueado, setCpfEmailBloqueado] = useState(false);

  // UseStates necessário para o useEffect de busca de informações pendentes, armazena a cota e a cota do usuario
  const [cotaId, setCotaId] = useState<number>();
  const [cotaUsuarioId, setCotaUsuarioId] = useState<any>(0);
  const [usuarioLogadoId, setUsuarioLogadoId] = useState<number>(0);
  const [pCotaUsuarioId, setPcotaUsuarioId] = useQueryParams({
    pCotaUsuarioId: NumberParam,
  });

  const [phone, setPhone] = useState("");
  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  // UseStates necessários para movimentação do Step

  // activeStep = 0 (Telas referente a cadastro empreendimento apartamento)
  // renderApSteps = 0 - De qual Empreendimento é sua Propriedade?

  // Empreendimento foi selecionado?

  // Sim
  // renderApSteps = 1 - Selecione seu apartamento?

  // Não

  // renderEmpSteps = 0 - Mensagem: Preenha informações de apartamento
  // renderEmpSteps = 1 - Conte-me mais sobre o empreendimento
  // renderEmpSteps = 2 - Conte-me mais sobre o Apartamento

  // renderApSteps = 3 - Mais informações do apartamento

  // activeStep = 1 (Telas referente a representante)
  const [activeStep, setActiveStep] = useState(0); // Passa para o próximo passo
  const [renderApSteps, setRenderApSteps] = useState(0); // Passa para o proximo render do fluxo de cadastro de Apartamentos
  const [renderEmpSteps, setRenderEmpSteps] = useState(0); //  Passa para o proximo render do fluxo de cadastro de Empreendimento
  const [renderCotaSteps, setRenderCotaSteps] = useState(0); // Passa para o proximo render do fluxo de Cotas
  const [renderPagamentoSteps, setRenderPagamentoSteps] = useState(0); // Passa para o proximo render do fluxo de Cotas
  const [renderPrioridadeSteps, setRenderPrioridadeSteps] = useState(0); // Passa para o proximo render do fluxo de Prioridade
  const [renderProprietario, setRenderProprietario] = useState(0); // Passa para o proximo render do fluxo titularidade da propriedade
  const [renderAdicionarPeriodo, setRenderAdicionarPeriodo] = useState(0);
  const [renderFinalizacao, setRenderFinalizacao] = useState(0);
  const [renderCronoFixo, setRenderCronoFixo] = useState(0);
  // UseStates necessários para o passo titularidade da propriedade
  const [propriedadeRes, setPropriedadeRes] = useState(0); // State que armazena o valor selecionado no Radio
  const [cronogramaFixoOuPrioridade, setCronogramaFixoOuPrioridade] =
    useState(0); // State que armazena o valor selecionado no Radio

  // UseStates necessários para o passo de atualização de cadastro, cadastro de proprietario, cadastrar empreendimento
  const [estados, setEstados] = useState<Estado[]>([]);
  const [cidades, setCidades] = useState<Cidade[]>([]);

  const [selectedEstado, setSelectedEstado] = useState<number>();
  const [selectedCidade, setSelectedCidade] = useState<number>();
  const [atualizado, setAtualizado] = useState<boolean>();
  const [paises, setPaises] = useState<Pais[]>([]);

  const [empreendimento, setEmpreendimento] = useState<Empreendimento[]>([]);

  const [empreedimentoSelecionado, setEmpreendimentoSelecionado] = useState<
    any | null
  >(null);
  const [empreendimentoNaoSelecionado, setEmpreendimentoNaoSelecionado] =
    useState<boolean>(false);

  // UseStates necessário para o passo de buscar informações do apartamento do empreendimento selecionado
  const [empreendimentoAp, setEmpreendimentoAp] = useState<ApData[]>([]);
  const [empreendimentoSelecionadoAp, setEmpreendimentoSelecionadoAp] =
    useState<any | null>(null);

  // UseStates necessários para o passo de especificações do apartamento selecionado
  const [apCriadoPeloUsuario, setApCriadoPeloUsuario] =
    useState<boolean>(false);
  const [apSelecionado, setApSelecionado] = useState<ApData | null>(null);
  const [formApartamento] = Form.useForm();

  // UseStates necessários para o passo de cadastro de apartamento e busca de empreendimento cadastrado
  const [possuiVaranda, setPossuiVaranda] = useState<number>();
  const [estacionamento, setEstacionamento] = useState<number>();
  const [terreo, setTerreo] = useState<number>();
  const [meusEmpreendimentos, setMeusEmpreendimentos] = useState<
    Empreendimentos[]
  >([]);

  // UseState necessário para armazenamento dos dados do formulario de cadastro do empreendimento
  const [formEmpreendimento, setFormEmpreendimento] = useState<Empreendimento>(
    {}
  );

  // UseState necessário para armazenamento dos dados do formulário de cadastro do apartamento
  const [formAp, setFormAp] = useState<Apartamento>({});

  // UseState necessário para armazenamento dos dados do formulário de mais informaçoes do apartamento
  const [formInfo, setFormInfo] = useState<MaisInfoAp>({});

  // UseState necessário para armazenamento do Id do empreendimento selecionado no formulario de cadastro de apartamento
  const [ApEmpreendimentoId, setApEmpreendimentoId] = useState<number>();

  // UseState necessário para armazenamento dos dados do formulario de atualização de cadastro do usuário
  const [formAtualizarCadastro, setFormAtualizarCadastro] = useState<Cadastro>(
    {}
  );

  // UseState necessário para armazenamento de dados do formulario de cadastro de proprietario
  const [formCadastroProprietario, setFormCadastroProprietario] =
    useState<Cadastro>({});

  const [formCadastroNovoProprietario, setFormCadastroNovoProprietario] =
    useState<Cadastro>({});

  // UseState necessário para armazenamento do id do proprietario, para futuras buscas de dados icompletos ----Em TESTE---
  const [proprietarioId, setProprietarioId] = useState<number>();

  //variável que controla o checkbox de Não encontrou empreendimento
  const [naoEncontrouEmpreendimento, setNaoEncontrouEmpreendimento] =
    useState<boolean>(false);

  // UseStates necessários para o componente de cota ou prioridade

  const cotaRef = useRef<boolean>();

  //bloqueia a edição dos campos caso a CTU tenha PEU
  const bloqueadoEdicao = useRef<boolean>(false);
  const prioridadeRef = useRef<boolean>();

  const changing = useRef<boolean>(false);

  const [valorCotaPrioridade, setValorCotaPrioridade] = useState<number>(0);

  // UseState para armazenamento se o usuario vai ou nao anunciar
  const [anunciar, setAnunciar] = useState<number>();

  // UseState para armazenamento das cotas do Usuario
  const [cotasUsuario, setCotasUsuario] = useState<Cotas[]>([]);

  // UseState para armazanemento e posterior verificação se existe cronograma dos empreendimentos
  // const [cronogramaEmp1, setCronogramaEmp1] = useState<number>();

  const cronogramaEmp = useRef(100);

  // UseRef necessário para referenciar se tem cronograma
  const cronogramaRef = useRef<number>(0);

  // UseRef necessário para referenciar se tem cronograma
  const cotaUsuarioRef = useRef<number>(0);

  // UseRef necessário para referenciar se tem cronograma
  const cotaIdRef = useRef<number>();

  // UseRef necessário para referenciar a origem do AP
  const origemApRef = useRef<number>(0);

  // UseRef necessário para referenciar o id do AP
  const idApRef = useRef<number>(0);
  // UseRef necessário para referenciar o id do AP
  const idEmpRef = useRef<number>(0);
  // UseRef necessário para referenciar a origem do AP
  const origemEmpRef = useRef<number>(0);

  // UseRef necessário para referenciar o representante
  const representanteRef = useRef<number>(0);

  // UseRef necessário para referenciar o id do Proprietario
  const proprietarioRef = useRef<number>(0);

  //UseState necessário para referenciar o marco
  const [state, setState] = useState<String>("");
  const stateNovo = useRef<String>("");

  // UseState para armazanemento e posterior verificação da origem dos apartamentos
  const [origemAp, setOrigemAp] = useState<number>();

  // UseState para armazenamento do formulario de informações da prioridade

  // const [formMinhaCota, setFormNumeroCota] = useState<any | null>(null);
  const [formPrioridade, setFormPrioridade] = useState({
    prioridade: null,
  });

  //UseState para armazenamento do ID da cota do usuario
  const [idMinhaCota, setIdMinhaCota] = useState<number>();
  const [minhaCotaUsuario, setMinhaCotaUsuario] = useState({
    saldoDevedor: null,
    valorCondominio: null,
    valorVenda: null,
  });
  const [origemMinhaCota, setOrigemMinhaCota] = useState<number>();

  // UseState para armazenamento do formulario de informações de quantas semanas por ano
  const [formSemanasPorAno, setFormSemanasPorAno] = useState({
    semanasPorAno: null,
  });

  // UseState necessário para armazenado do formulario MaisInfo
  const [formMaisInfo, setFormMaisInfo] = useState({
    saldoDevedor: null,
    valorCondominio: null,
    valorVenda: null,
    situacao: null,
  });
  // UseState para armazenamento do formulario de informações da prioridade
  const [formDiaDaSemana, setFormDiaDaSemana] = useState({
    diaDaSemana: null,
  });

  const [formMinhaCota, setFormMinhaCota] = useState({
    id: null,
    numeroCota: null,
  });
  const [formMinhaCotaOrigemProprietario, setFormMinhaCotaOrigemProprietario] =
    useState({ numeroCota: undefined });

  //necessário para apresentação das mensagens de erro e sucesso
  const [messageApi, contextHolder] = message.useMessage();

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [uploading, setUploading] = useState(false);

  const [] = Form.useForm();

  const [formAtualizarEstadoEmpreendimento] = Form.useForm();
  const [formAtualizarEstadoCadastro] = Form.useForm();
  const [formAtualizarEstadoDadosProprietario] = Form.useForm();

  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

  //UseEffect para resgatar dados pendentes, caso o usuario nao tenha finalizado todo o cadastro
  // dependendo do step onde ele parou, irá recomeçar exatamente onde ele parou
  // useEffect(() => {
  //   resgatarDadosPendentes();
  // }, []);

  useEffect(() => {
    const buscarCota = async () => {
      if (pCotaUsuarioId.pCotaUsuarioId) {
        if (pCotaUsuarioId.pCotaUsuarioId !== 0) {
          const result = buscarDadosCotaUsuario();
          if (await result) {
            setCotaUsuarioId(+pCotaUsuarioId.pCotaUsuarioId);
            isLoading.current = false;
          } else {
            error("Erro ao buscar a propriedade");
          }
        } else {
          setCotaUsuarioId(+pCotaUsuarioId.pCotaUsuarioId);
        }
      }
      // resgatarDadosPendentes();
    };
    buscarCota();
  }, []);

  // UseEffect necessário para buscar os Paises
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/pais`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const paises: Pais[] = response.data;

            // Filtrando os paises com origem igual a 0
            const paisesComOrigemZero = paises.filter(
              (pais: Pais) => pais.origem === 0
            );

            setPaises(paisesComOrigemZero);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          } else {
            console.error("Erro ao buscar paises:", error);
          }
        }
      } else {
        document.location.href = "/login";
      }
    };
    fetchToken();
  }, []);

  // UseEffect necessário para Buscar Estado
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/estado`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const estados: Estado[] = response.data;

            // Filtrando os estados com origem igual a 0
            const estadosComOrigemZero = estados.filter(
              (estado: Estado) => estado.origem === 0
            );

            setEstados(estadosComOrigemZero);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          } else {
            console.error("Erro ao buscar estados:", error);
          }
        }
      }
    };
    fetchToken();
  }, []);

  //Buscar Cidade de acordo com o Estado selecionado
  useEffect(() => {
    if (selectedEstado) {
      const fetchToken = async () => {
        const Token = validateToken();

        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/cidade`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              const cidades: Cidade[] = response.data;
              // Filtrando as cidades selecionadas
              const cidade = cidades.filter(
                (cidade: Cidade) => cidade.estadoId === selectedEstado
              );

              setCidades(cidade);
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
              console.log(error);
            } else {
              console.error("Erro ao buscar cidades:", error);
            }
          }
        }
      };
      fetchToken();
    }
  }, [selectedEstado]);

  // UseEffect necessário para buscar os empreendimentos
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/empreendimento/system`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const empreend = await response.data;

            setEmpreendimento(empreend);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          }
        }
      }
    };
    fetchToken();
  }, []);

  //UseState necessário de seleção do empreendimento
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token && empreedimentoSelecionado) {
        const URL = `${Globais.DOMINIOBACK}/apto/info/${empreedimentoSelecionado.id}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const empreend = await response.data;
            setEmpreendimentoSelecionadoAp(response.data.id);

            setEmpreendimentoAp(empreend);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          }
        }
      }
    };
    fetchToken();
  }, [empreedimentoSelecionado]);

  //UseEffect necessário para trazer as informações do apartamento selecionado
  useEffect(() => {
    if (empreendimentoSelecionadoAp) {
      const fetchToken = async () => {
        const Token = validateToken();
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/apto/${empreendimentoSelecionadoAp.id}`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              const ape = response.data;
              setFormAp((prevState) => ({
                ...prevState, // mantém os valores antigos do estado
                id: response.data.id, // atualiza id com o valor da resposta
              }));

              setApEmpreendimentoId(response.data.id);

              setApSelecionado(ape);
              formApartamento.setFieldsValue({
                propriedade: {
                  capacidade: ape.capacidade,
                  quartos: ape.quartos,
                  banheiros: ape.banheiros,
                  metragem: ape.metragem,
                  varanda:
                    ape.varanda === 1
                      ? "Sim"
                      : ape.varanda === 2
                      ? "Não"
                      : "Não definido",
                  terreo:
                    ape.terreo === 1
                      ? "Sim"
                      : ape.terreo === 2
                      ? "Não"
                      : "Não definido",
                  estacionamento:
                    ape.estacionamento === 1
                      ? "Sim"
                      : ape.estacionamento === 2
                      ? "Não"
                      : "Não definido",
                },
              });
            }
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logout();
              console.log(error);
            }
          }
        }
      };
      fetchToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empreendimentoSelecionadoAp]);

  //UseEffect necessário que traz as informações do usuario, caso ele tenha estado civil e nacionalidade.
  useEffect(() => {
    const buscarInfoUsuario = async () => {
      const Token = validateToken();
      if (Token) {
        const tokenId = Token.id;
        const URL = `${Globais.DOMINIOBACK}/usuario/${tokenId}`;
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (
          response.data &&
          response.data.estadoCivil &&
          Object.keys(response.data.estadoCivil).length > 0 &&
          response.data.nacionalidade &&
          Object.keys(response.data.nacionalidade).length > 0
        ) {
          setFormAtualizarCadastro((prevState) => ({
            ...prevState,
            estadoCivil: response.data.estadoCivil,
            nacionalidade: response.data.nacionalidade,
            rg: response.data.rg,
          }));
        }
      }
    };
    buscarInfoUsuario();
  }, []);

  //UseEffect necessário que traz as informações do usuario, caso ele tenha endereço.
  useEffect(() => {
    const buscarInfoUsuario = async () => {
      const Token = validateToken();
      if (Token) {
        const tokenId = Token.id;
        const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${tokenId}`;

        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response.data && Object.keys(response.data).length > 0) {
          setFormAtualizarCadastro((prevState) => ({
            ...prevState,
            endereco: response.data.endereco,
            complemento: response.data.complemento,
            estadoId: response.data.estadoId,
            cidadeId: response.data.cidadeId,
          }));
        }
      }
    };
    buscarInfoUsuario();
  }, []);

  // UseEffect necessário para realizar a busca após o envio do comprovante
  useEffect(() => {
    const buscarMeuArquivo = async () => {
      const formData = new FormData();
      const Token = validateToken();
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/arquivo-cota-usuario/cotaUsuario/${cotaUsuarioRef.current}`;

        try {
          const response = await axios.get(URL, {
            headers: {
              Authorization: Token.AuthStr,
              "Content-type": "multipart/form-data",
            },
          });

          setUploadedFiles(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    };
    buscarMeuArquivo();
  }, [uploading]);

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };

  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const criandoTelaFinalizacao = async (cotaUsuarioId: number) => {
    let texto = "";

    const resultPagamentoAtiva = await verificarPagamentoPorStatus(
      "ATIVA",
      cotaUsuarioId
    );

    if (resultPagamentoAtiva) {
      setPagamentoRegularizado("Sim");
    } else {
      const resultPagamentoPendente = verificarPagamentoPorStatus(
        "PENDENTE",
        cotaUsuarioId
      );
      if (await resultPagamentoPendente) {
        setPagamentoRegularizado("Não. Aguardando confirmação");
        texto +=
          "Vi aqui que seu pagamento ainda está pendente. \n Se já efetuou o pagamento não se preocupe, aguarde a confirmação.\n";
      } else {
        setPagamentoRegularizado("Não há pagamentos");
      }
    }

    const representantes = await buscarTodosOsRepresentantesCotaUsuario(
      cotaUsuarioId
    );
    if (representantes) {
      if (
        representantes[0].checked === 0 &&
        representantes[0].dataVencimento === null
      ) {
        setRepresentanteRegularizado("Não");
        texto +=
          "Consta que o representante não está regularizado.\n Se já incluiu os dados do representante basta aguardar a equipe terminar o procedimento.\n";
      } else {
        setRepresentanteRegularizado("Sim");
      }
    } else {
      setRepresentanteRegularizado("Não há representantes");
    }

    const resultCTUChecada = verificarCTUChecada(cotaUsuarioId);
    if (await resultCTUChecada) {
      setPropriedadeAutenticada("Sim");
    } else {
      setPropriedadeAutenticada("Não");
      texto +=
        "Sua propriedade ainda não está autenticada, \n se já incluiu o comprovante basta aguardar a equipe confirmar o procedimento.\n";
    }

    const result = verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
    if (await result) {
      bloqueadoEdicao.current = true;
      setBloquearBotaoProximo(false);
      setPropriedadeTemPeriodos("Sim");
      setPropriedadeTemPeriodosDefinidos("Sim");
      texto +=
        "Quanto aos seus períodos está tudo certo. \n Agora basta aguardar que entraremos em contato caso existam interessados nos seus períodos.";
    } else {
      const result = verificarSeTemPeriodoUsuario(cotaUsuarioId);
      if (await result) {
        setPropriedadeTemPeriodos("Sim");
        setPropriedadeTemPeriodosDefinidos("Não");
      } else {
        setPropriedadeTemPeriodos("Não");
        setPropriedadeTemPeriodosDefinidos("Não");
      }
    }

    setTextoFinalizacao(texto);
  };

  const telaDePagamento = async () => {
    const resultPagamentoAtivo = await verificarPagamentoPorStatus(
      "ATIVA",
      cotaUsuarioId
    );
    const resultPagamentoPendente = await verificarPagamentoPorStatus(
      "PENDENTE",
      cotaUsuarioId
    );
    if (resultPagamentoAtivo || resultPagamentoPendente) {
      switch (anunciar) {
        case 1:
          const result = await verificarSeMaisInformacoesAnuncioEstaoAusentes(
            cotaUsuarioId
          );
          if (result) {
            setBloquearBotaoProximo(true);
          }
          setActiveStep(3);
          setRenderPagamentoSteps(2);

          break;
        case 2:
          let sucesso;
          switch (cronogramaEmp.current) {
            case 0:
              const periodosDefinidos =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidos) {
                setActiveStep(6);
              } else {
                const temPeriodos = await verificarSeTemPeriodoUsuario(
                  cotaUsuarioId
                );
                if (temPeriodos) {
                  sucesso = atualizarCotaUsuario(
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                  );
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(3);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-074");
                  }
                } else {
                  sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(4);
                    setRenderAdicionarPeriodo(1);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-073");
                  }
                }
              }

              break;
            case 1:
              const periodosDefinidosCase1 =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidosCase1) {
                setActiveStep(6);
              } else {
                sucesso = atualizarCotaUsuario("AGUARDANDO_DEFINICAO_PERIODOS");
                if (await sucesso) {
                  changing.current = false;
                  //indo para mensagem de desistencia pagamento
                  setActiveStep(5);
                  setRenderAdicionarPeriodo(3);
                } else {
                  error("Há algo de errado. Código de erro: VCP-074");
                }
              }

              break;

            case 2:
              const periodosDefinidosCase2 =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidosCase2) {
                setActiveStep(6);
              } else {
                const temPeriodos = await verificarSeTemPeriodoUsuario(
                  cotaUsuarioId
                );
                if (temPeriodos) {
                  sucesso = atualizarCotaUsuario(
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                  );
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(3);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-074");
                  }
                } else {
                  sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(4);
                    setRenderAdicionarPeriodo(2);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-075");
                  }
                }
              }

              break;
          }
          break;
      }
    } else {
      setActiveStep(3);
      setRenderPagamentoSteps(1);
    }
  };

  const buscarDadosCotaUsuario = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario/${pCotaUsuarioId.pCotaUsuarioId}`;

      setUsuarioLogadoId(+Token.id);

      const tokenId = Token.id;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        setMinhaCotaUsuario((prevState) => ({
          ...prevState,
          saldoDevedor: response.data.saldoDevedor,
          valorCondominio: response.data.valorCondominio,
          valorVenda: response.data.valorVenda,
        }));

        // Armazena as informaços de cota Usuario ao formulario Mais Info Anuncio
        setFormMaisInfo({
          saldoDevedor: response.data.saldoDevedor,
          valorCondominio: response.data.valorCondominio,
          valorVenda: response.data.valorVenda,
          situacao: response.data.situacao,
        });

        setMinhaSituacao(response.data.situacao);
        let isAuthorized = true;
        setCotaUsuarioId(response.data.id);

        if (
          response.data.usuarioId !== tokenId &&
          pCotaUsuarioId.pCotaUsuarioId !== 0
        ) {
          // VERIFICA SE A COTA USUARIO PERTENCE AO USUARIO LOGADO
          const URLRepresentante = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;
          try {
            // VERIFICA SE A COTA USUARIO PERTENCE AO USUARIO LOGADO COMO REPRESENTANTE
            const representante = await axios.get(URLRepresentante, {
              headers: { Authorization: Token.AuthStr },
            });

            if (representante) {
              let resultado = representante.data.filter((p: any) => {
                if (p.cotasUsuariosId === pCotaUsuarioId.pCotaUsuarioId) {
                  return p;
                }
              });
              if (resultado.length === 0) {
                isAuthorized = false;
              } else {
                representanteRef.current = 1;
              }
            } else {
              error("Há algo de errado. Código de erro: VCP-039");
            }
          } catch (error) {
            console.error(error);
            isAuthorized = false; // Se der erro, também não será autorizado
          }
        }

        // Verifica se está autorizado antes de continuar
        if (!isAuthorized) {
          // SE NÃO FOR ENCONTRADO, O USUARIO É REDIRECIONADO A HOME
          error("Acesso negado: usuário não autorizado.");
          setTimeout(() => {
            document.location.href = "/cadastroCotas";
          }, 2000);

          return false; // Sai da função se não estiver autorizado
        } else {
          setCotaUsuarioId(response.data.id);
          setCotaId(response.data.cotaId);
          formPrioridade.prioridade = response.data.prioridade
            ? response.data.prioridade
            : null;

          if (origemEmpRef.current === 0) {
            setNaoEncontrouEmpreendimento(false);
            setEmpreendimentoNaoSelecionado(false);
          } else {
            setNaoEncontrouEmpreendimento(true);
            setEmpreendimentoNaoSelecionado(true);
          }

          switch (response.data.status) {
            case "AGUARDANDO_APTO":
              setFormInfo(response.data);

              const sucessoMinhaCotaAptoMaisApto = await buscarMinhaCota(
                response.data.cotaId
              );
              if (sucessoMinhaCotaAptoMaisApto) {
                setBloquearBotaoProximo(true);
                setRenderEmpSteps(3);
                setActiveStep(0);

                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                } else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  setApCriadoPeloUsuario(false);
                }
                stateNovo.current = "AGUARDANDO_APTO";
                setState("AGUARDANDO_APTO");
              } else {
                error("Há algo de errado. Código erro: VCP-009");
              }

              return true;
            case "AGUARDANDO_TITULARIDADE":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_TITULARIDADE";
              setState("AGUARDANDO_TITULARIDADE");

              const [
                sucessobuscarMinhaCota,
                sucessobuscarDadosProprietario,
                sucessobuscarEndereco,
                sucessoDadosRepresentante,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "representante"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucessobuscarMinhaCota &&
                sucessobuscarDadosProprietario &&
                sucessobuscarEndereco &&
                sucessoDadosRepresentante
              ) {
                //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setActiveStep(1);
                  setApCriadoPeloUsuario(true);
                  setEmpreendimentoSelecionado(null);
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                //EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setActiveStep(1);
                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                else {
                  setActiveStep(1);
                  setApCriadoPeloUsuario(false);
                }

                if (propriedadeRes === 0) {
                  setBloquearBotaoProximo(true);
                }

                return true;
              } else {
                return false;
              }
            case "AGUARDANDO_REPRESENTANTE":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_REPRESENTANTE";
              setState("AGUARDANDO_REPRESENTANTE");

              setPropriedadeRes(2);
              setBloquearBotaoProximo(false);

              const [
                sucessobuscarMinhaCotaRep,
                sucessobuscarDadosProprietarioRep,
                sucessobuscarEnderecoRep,
                sucessoDadosRepresentanteRep,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "representante"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucessobuscarMinhaCotaRep &&
                sucessobuscarDadosProprietarioRep &&
                sucessobuscarEnderecoRep &&
                sucessoDadosRepresentanteRep
              ) {
                //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setRenderEmpSteps(4);

                  setApCriadoPeloUsuario(true);
                  setEmpreendimentoSelecionado(null);
                }
                //EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setRenderApSteps(3);

                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                else {
                  setRenderApSteps(3);

                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                return true;
              } else {
                return false;
              }
            case "AGUARDANDO_COMPROVANTE":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_COMPROVANTE";
              setState("AGUARDANDO_COMPROVANTE");

              const [
                sucesso,
                sucessoProprietario,
                sucessoEnderecoProprietario,
                sucessoRepresentante,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucesso &&
                sucessoProprietario &&
                sucessoEnderecoProprietario &&
                sucessoRepresentante
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);
                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setRenderApSteps(3);
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);

                  setRenderApSteps(3);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                setRenderProprietario(4);
                setActiveStep(1);
                const resultado = await verificarSeTemArquivos(cotaUsuarioId);
                if (resultado) {
                  setBloquearBotaoProximo(false);
                } else {
                  setBloquearBotaoProximo(true);
                }

                return true;
              } else {
                console.log("Falha ao obter todas as informações necessárias");
                return false;
              }
            case "AGUARDANDO_COTA":
              setFormInfo(response.data);

              cotaUsuarioRef.current = response.data.id;
              stateNovo.current = "AGUARDANDO_COTA";
              buscarMeuArquivo();
              setState("AGUARDANDO_COTA");
              const [
                sucessoAGCT,
                sucessoProprietarioAGCT,
                sucessoEnderecoProprietarioAGCT,
                sucessoRepresentanteAGCT,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucessoAGCT &&
                sucessoProprietarioAGCT &&
                sucessoEnderecoProprietarioAGCT &&
                sucessoRepresentanteAGCT
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);

                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                switch (cronogramaEmp.current) {
                  case 0:
                    prioridadeRef.current = true;
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(1);
                    setRenderCotaSteps(0);
                    setActiveStep(2);
                    break;
                  case 1:
                    console.log("1");
                    console.log(cronogramaFixoOuPrioridade);
                    cotaRef.current = true;
                    buscarCotas();
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(1);
                    if (
                      formMinhaCotaOrigemProprietario.numeroCota ===
                        undefined ||
                      formMinhaCotaOrigemProprietario.numeroCota === 0
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      console.log("2");
                      setBloquearBotaoProximo(false);
                    }
                    setActiveStep(2);
                    break;
                  case 2:
                    setEmpreendimentoSelecionado(null);
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(0);
                    setActiveStep(2);
                    break;
                }

                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                if (cronogramaFixoOuPrioridade === 0) {
                  console.log("3");
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }

                return true;
              } else {
                error("Há algo de errado. Còdigo de erro: VCP-053");
                return false;
              }
            case "AGUARDANDO_DEFINICAO_ANUNCIO":
              setState("AGUARDANDO_DEFINICAO_ANUNCIO");
              stateNovo.current = "AGUARDANDO_DEFINICAO_ANUNCIO";
              setFormInfo(response.data);
              setBloquearBotaoProximo(true);

              cotaUsuarioRef.current = response.data.id;

              buscarMeuArquivo();
              const [
                sucessoAGPGT,
                sucessoProprietarioAGPGT,
                sucessoEnderecoProprietarioAGPGT,
                sucessoRepresentanteAGPGT,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPGT &&
                sucessoProprietarioAGPGT &&
                sucessoEnderecoProprietarioAGPGT &&
                sucessoRepresentanteAGPGT
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);

                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                  setRenderApSteps(3);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                  setRenderApSteps(3);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }

                // Faz a verificação se existe cronograma, se sim vai para tela de cotas se nao , volta para a tela de prioridades
                if (cronogramaRef.current !== 0) {
                  cotaRef.current = true;
                  setRenderCotaSteps(1);
                } else {
                  prioridadeRef.current = true;
                  setRenderPrioridadeSteps(3);
                }
                setRenderProprietario(4);

                buscarCotas();
                telaDePagamento();

                return true;
              } else {
                console.log("Falha ao obter todas as informações necessárias");
                return false;
              }
            case "AGUARDANDO_MAISINFO_ANUNCIO":
              setState("AGUARDANDO_MAISINFO_ANUNCIO");
              stateNovo.current = "AGUARDANDO_MAISINFO_ANUNCIO";
              setFormInfo(response.data);
              setBloquearBotaoProximo(true);

              cotaUsuarioRef.current = response.data.id;

              buscarMeuArquivo();
              const [
                sucessoAGPGTMINFO,
                sucessoProprietarioAGPGTMINFO,
                sucessoEnderecoProprietarioAGPGTMINFO,
                sucessoRepresentanteAGPGTMINFO,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPGTMINFO &&
                sucessoProprietarioAGPGTMINFO &&
                sucessoEnderecoProprietarioAGPGTMINFO &&
                sucessoRepresentanteAGPGTMINFO
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                  setRenderApSteps(3);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                  setRenderApSteps(3);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                setRenderProprietario(4);

                if (
                  minhaCotaUsuario.saldoDevedor === null ||
                  minhaCotaUsuario.valorCondominio === null ||
                  minhaCotaUsuario.valorVenda === null
                ) {
                  // setBloquearBotaoProximo(true);
                }

                buscarCotas();
                setAnunciar(1);

                setRenderPagamentoSteps(2);
                setActiveStep(3);

                return true;
              } else {
                console.log("Falha ao obter todas as informações necessárias");
                return false;
              }
            case "AGUARDANDO_PERIODOS":
              setFormInfo(response.data);
              setBloquearBotaoProximo(false); //

              cotaUsuarioRef.current = response.data.id;
              formPrioridade.prioridade = response.data.prioridade;

              buscarMeuArquivo();
              stateNovo.current = "AGUARDANDO_PERIODOS";
              setState("AGUARDANDO_PERIODOS");
              const [
                sucessoAGPE,
                sucessoProprietarioAGPE,
                sucessoEnderecoProprietarioAGPE,
                sucessoRepresentanteAGPE,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPE &&
                sucessoProprietarioAGPE &&
                sucessoEnderecoProprietarioAGPE &&
                sucessoRepresentanteAGPE
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);
                  setRenderApSteps(0);
                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                  setRenderApSteps(3);
                  setRenderEmpSteps(0);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                  setRenderApSteps(3);
                  setRenderEmpSteps(0);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }

                buscarCotas();

                const assinatura = await buscarAssinaturaPorCotaUsuario(
                  cotaUsuarioRef.current
                );
                if (assinatura) {
                  setAnunciar(1);
                } else {
                  setAnunciar(2);
                }

                switch (cronogramaEmp.current) {
                  case 0:
                    setActiveStep(4);
                    if (origemApRef.current !== 0) {
                      setRenderAdicionarPeriodo(2);
                    } else {
                      setRenderAdicionarPeriodo(1);
                    }

                    setCronogramaFixoOuPrioridade(2);
                    break;
                  case 1:
                    setActiveStep(5);
                    if (origemApRef.current !== 0) {
                      setRenderAdicionarPeriodo(4);
                    } else {
                      setRenderAdicionarPeriodo(3);
                    }

                    setCronogramaFixoOuPrioridade(1);
                    break;
                  case 2:
                    setActiveStep(4);
                    setRenderAdicionarPeriodo(2);

                    break;
                }
                return true;
              } else {
                error("Há algo de errado. Código de erro: VCP-076");
                return false;
              }

            case "AGUARDANDO_DEFINICAO_PERIODOS":
              setBloquearBotaoProximo(false);

              // não tem periodos definidos. vai para a mensagem de definição.
              setFormInfo(response.data);
              setBloquearBotaoProximo(false);
              cotaUsuarioRef.current = response.data.id;

              formPrioridade.prioridade = response.data.prioridade;
              buscarMeuArquivo();
              stateNovo.current = "AGUARDANDO_DEFINICAO_PERIODOS";
              setState("AGUARDANDO_DEFINICAO_PERIODOS");
              const [
                sucessoAGPDE,
                sucessoProprietarioAGPDE,
                sucessoEnderecoProprietarioAGPDE,
                sucessoRepresentanteAGPDE,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPDE &&
                sucessoProprietarioAGPDE &&
                sucessoEnderecoProprietarioAGPDE &&
                sucessoRepresentanteAGPDE
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);

                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }

                buscarCotas();

                const assinatura = await buscarAssinaturaPorCotaUsuario(
                  cotaUsuarioRef.current
                );
                if (assinatura) {
                  setAnunciar(1);
                } else {
                  setAnunciar(2);
                }

                switch (cronogramaEmp.current) {
                  case 0:
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(4);
                    console.log("2");
                    setCronogramaFixoOuPrioridade(2);
                    break;
                  case 1:
                    setActiveStep(5);
                    if (origemApRef.current !== 0) {
                      setRenderAdicionarPeriodo(4);
                    } else {
                      setRenderAdicionarPeriodo(3);
                    }

                    setCronogramaFixoOuPrioridade(1);
                    break;
                  case 2:
                    console.log("3");
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(4);
                    setCronogramaFixoOuPrioridade(2);
                    break;
                }
              }

              return true;

            case "AGUARDANDO_APTOMAISINFO":
              setFormInfo(response.data);
              const sucessoMinhaCotaAptoMaisInfo = await buscarMinhaCota(
                response.data.cotaId
              );
              stateNovo.current = "AGUARDANDO_APTOMAISINFO";
              setState("AGUARDANDO_APTOMAISINFO");
              if (sucessoMinhaCotaAptoMaisInfo) {
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                else {
                  setApCriadoPeloUsuario(false);
                }

                if (
                  response.data.numeroApto === null ||
                  response.data.andar === null ||
                  response.data.vista === null
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }

                setActiveStep(0);
                setRenderApSteps(3);
                setRenderEmpSteps(0);

                setState("AGUARDANDO_APTOMAISINFO");
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                break;
              } else {
                error("Há algo de errado. Código erro: VCP-001.");
                break;
              }

            default:
              setBloquearBotaoProximo(false);

              criandoTelaFinalizacao(response.data.id);

              setFormInfo(response.data);

              cotaUsuarioRef.current = response.data.id;

              formPrioridade.prioridade = response.data.prioridade;
              buscarMeuArquivo();
              stateNovo.current = response.data.status;

              const [
                sucessoDFT,
                sucessoProprietarioDFT,
                sucessoEnderecoProprietarioDFT,
                sucessoRepresentanteDFT,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              setActiveStep(0);
              setRenderApSteps(0);

              if (
                sucessoDFT &&
                sucessoProprietarioDFT &&
                sucessoEnderecoProprietarioDFT &&
                sucessoRepresentanteDFT
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                // Faz a verificação se existe cronograma, se sim vai para tela de cotas se nao , volta para a tela de prioridades
                if (cronogramaRef.current !== 0) {
                  cotaRef.current = true;
                } else {
                  prioridadeRef.current = true;
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                const assinatura = await buscarAssinaturaPorCotaUsuario(
                  cotaUsuarioRef.current
                );
                if (assinatura) {
                  setAnunciar(1);
                } else {
                  setAnunciar(2);
                }

                const anuncioPropriedade = await verificarAnuncioPropriedade();
                if (anuncioPropriedade) {
                  setAnuncioPropriedade(true);
                } else {
                  setAnuncioPropriedade(false);
                }

                return true;
              } else {
                error("Há algo de errado. Código de erro: VCP-078");
                return false;
              }
          }
        }
      } catch (error) {
        console.error(error);
        error("Há algo de errado. Código de erro: VCP-079");
      }
      return true;
    } else {
      document.location.href = "/login";
      return false;
    }
  };

  // Função que busca a cota
  const buscarMinhaCota = async (cotaId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota/${cotaId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setIdMinhaCota(response.data.id);

          setOrigemMinhaCota(response.data.origem);
          formMinhaCotaOrigemProprietario.numeroCota = response.data.numeroCota;
          formSemanasPorAno.semanasPorAno = response.data.qtdSemanas;
          formDiaDaSemana.diaDaSemana = response.data.diaDaSemanaInicio;

          // setFormSemanasPorAno(response.data.qtdSemanas);

          // setFormMinhaCotaOrigemProprietario(response.data.numeroCota);

          if (cotaUsuarioId !== 0) {
            setFormMinhaCota((prevState) => ({
              ...prevState,
              numeroCota: response.data.numeroCota,
            }));
            // setFormSemanasPorAno({
            //   semanasPorAno: response.data.qtdSemanas,
            // })
          }

          // Aguarda a conclusão da função buscarMeuAp
          const sucessoAp = await buscarMeuAp(response.data.aptoId);

          if (!sucessoAp) {
            error("Há algo de errado. Código de erro: VCP-055");
            return false;
          }

          // setFormSemanasPorAno(response.data.qtdSemanas);

          // setFormDiaDaSemana(response.data.diaDaSemanaInicio);
        } else {
          error("Há algo de errado. Código de erro: VCP-056");
          return false;
        }

        return true;
      } catch (error) {
        error("Há algo de errado. Código de erro: VCP-057");
        return false;
      }
    } else {
      return false;
    }
  };

  // Função que busca a cota do usuario
  const buscarMinhaCotaUsuario = async (
    cotaUsuarioId: number
  ): Promise<CotaUsuario | null> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        formPrioridade.prioridade = response.data.prioridade
          ? response.data.prioridade
          : null;

        return response.data;
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-058");
        return null;
      }
    } else {
      return null;
    }
  };

  // Função que busca o apartamento do usuario
  const buscarMeuAp = async (apId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/apto/${apId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setOrigemAp(response.data.origem);
          origemApRef.current = response.data.origem;
          idApRef.current = response.data.id;
          const values: Apartamento = {
            id: response.data.id,
            empreendId: response.data.empreendId,
            nome: response.data.nome,
            capacidade: response.data.capacidade,
            quartos: response.data.quartos,
            banheiros: response.data.banheiros,
            varanda: response.data.varanda,
            metragem: response.data.metragem,
            estacionamento: response.data.estacionamento,
            terreo: response.data.terreo,
            vista: response.data.vista,
          };

          setFormAp(values);

          formApartamento.setFieldsValue({
            propriedade: {
              nomeAp: values.nome,
              capacidade: values.capacidade,
              quartos: values.quartos,
              banheiros: values.banheiros,
              varanda: values.varanda,
              metragem: values.metragem,
              estacionamento: values.estacionamento,
              terreo: values.terreo,
              vista: values.vista,
            },
          });

          // Aguarda a conclusão da função buscarMeuEmp
          const sucessoEmp = await buscarMeuEmp(response.data.empreendId);
          setApEmpreendimentoId(response.data.id);

          if (!sucessoEmp) {
            error("Há algo de errado. Código de erro: VCP-059");
            return false;
          }
        }

        return true;
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-060");
        return false;
      }
    } else {
      return false;
    }
  };

  // Função que busca o empreendimento do usuario
  const atualizarMeuEmp = async (empreendId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento/${empreendId}`;
      const cronogramaNovo =
        cronogramaFixoOuPrioridade === 1
          ? 1
          : cronogramaFixoOuPrioridade === 2
          ? 0
          : null;

      const values = {
        cronograma: cronogramaNovo,
      };

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response) {
          return true;
        } else {
          error("Há algo de errado. Código de erro: VCP-064");
          return false;
        }
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-063");
        return false;
      }
    } else {
      document.location.href = "/login";
      return false;
    }
  };

  // Função que busca o empreendimento do usuario
  const buscarMeuEmp = async (empreendId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento/${empreendId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        console.log("1");

        if (response && response.data) {
          const values = {
            nome: response.data.nome,
            cronograma: response.data.cronograma,
          };
          console.log("2");

          switch (response.data.origem) {
            case 0:
              console.log("3");
              switch (response.data.cronograma) {
                case 0:
                  cronogramaEmp.current = 0;
                  break;
                case 1:
                  cronogramaEmp.current = 1;
                  break;
              }
              break;
            default:
              console.log("4");
              cronogramaEmp.current = 2;
              // if(response.data.cronograma === 0){
              //   setCronogramaFixoOuPrioridade(1);
              // }else{
              //   setCronogramaFixoOuPrioridade(2);
              // }
              break;
          }

          setFormEmpreendimento(values);
          setEmpreendimentoSelecionado(response.data);

          console.log("stateNovo.current");

          console.log(stateNovo.current);

          switch (await stateNovo.current) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
            case "AGUARDANDO_TITULARIDADE":
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_COMPROVANTE":
            case "AGUARDANDO_COTA":
            case "":
              break;
            default:
              console.log("aqui");
              const cronogramaFixoOuPrioridadeNovo =
                response.data.cronograma == 1
                  ? 1
                  : response.data.cronograma == 0
                  ? 2
                  : 0;

              setCronogramaFixoOuPrioridade(cronogramaFixoOuPrioridadeNovo);

              break;
          }

       
          if (
            cronogramaFixoOuPrioridade !== 0 &&
            renderCotaSteps === 0 &&
            renderPrioridadeSteps === 0
          ) {
            setBloquearBotaoProximo(false);
          }

          cronogramaRef.current = values.cronograma;
          origemEmpRef.current = response.data.origem;
          idEmpRef.current = response.data.id;

          buscarMinhaCidade(response.data.cidadeId, "empreendimento");
          setFormAp((prevState) => ({
            ...prevState, // mantém os valores antigos do estado
            empreendId: response.data.nome, // atualiza empreendId com o valor da resposta
          }));
        }

        return true;
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-061");
        return false;
      }
    } else {
      return false;
    }
  };
  // const buscarMeuEmpSemAp = async (usuarioId: number): Promise<boolean> => {
  //   const Token = validateToken();
  //   if (Token) {
  //     const URL = `${Globais.DOMINIOBACK}/empreendimento`;
  //     const tokenId = Token.id;
  //     try {
  //       const response = await axios.get(URL, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: Token.AuthStr,
  //         },
  //       });

  //       if (response && response.data) {
  //         const sortedData = response.data.sort(
  //           (a: any, b: any) =>
  //             new Date(b.created_at).getTime() -
  //             new Date(a.created_at).getTime()
  //         );
  //         let meuEmp = null;

  //         for (let i = 0; i < sortedData.length; i++) {
  //           const item = sortedData[i];
  //           if (item.origem === usuarioId) {
  //             meuEmp = item;

  //             break;
  //           }
  //         }

  //         const values = {
  //           id: meuEmp.id,
  //           nome: meuEmp.nome,
  //           origem: meuEmp.origem,
  //           cronograma: meuEmp.cronograma,
  //           cidadeId: meuEmp.cidadeId,
  //         };

  //         setFormEmpreendimento(values);
  //         setEmpreendimentoSelecionado(meuEmp);

  //         cronogramaEmp.current = values.cronograma;

  //         cronogramaRef.current = values.cronograma;
  //         origemEmpRef.current = values.origem;

  //         buscarMinhaCidade(values.cidadeId, "empreendimento");
  //         buscarMeusEmpreendimentos();
  //       }

  //       return true;
  //     } catch (error) {
  //       console.log(error);
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // };

  // Função que busca a cidade resgitrada pelo usuario
  const buscarMinhaCidade = async (cidadeId: number, tipo: string) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cidade/${cidadeId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          if (tipo === "proprietario") {
            setFormCadastroProprietario((prevState) => ({
              ...prevState,
              cidadeId: response.data.nome,
            }));
          } else if (tipo === "representante") {
            setFormAtualizarCadastro((prevState) => ({
              ...prevState,
              cidadeId: response.data.nome,
            }));
          } else if (tipo === "empreendimento") {
            setFormEmpreendimento((prevState) => ({
              ...prevState,
              cidadeId: response.data.nome,
            }));
          }

          buscarMeuEstado(response.data.estadoId);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Função que busca o estado registrado pelo usuário
  const buscarMeuEstado = async (estadoId: number) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/estado/${estadoId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setFormEmpreendimento((prevState) => ({
            ...prevState, // mantém os valores antigos do estado
            estado: response.data.nome, // atualiza empreendId com o valor da resposta
          }));
          setSelectedEstado(response.data.nome);
          buscarMeuPais(response.data.paisId);
        }

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // Função que busca o pais registrado pelo usuario
  const buscarMeuPais = async (paisId: number) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/pais/${paisId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setFormEmpreendimento((prevState) => ({
            ...prevState, // mantém os valores antigos do estado
            pais: response.data.nome, // atualiza empreendId com o valor da resposta
          }));
        }

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const regularizarCTUAguardandoMaisInfoAnuncio = async () => {
    const representantes = await buscarTodosOsRepresentantesCotaUsuario(
      cotaUsuarioId
    );
    if (representantes) {
      if (
        representantes[0].checked === 0 &&
        representantes[0].dataVencimento === null
      ) {
        const result = await atualizarCotaUsuario("AGUARDANDO_PROCURACAO");
        if (result) {
          criandoTelaFinalizacao(cotaUsuarioId);
          setActiveStep(6);
        } else {
          error("Há algo de errado. VCP-090");
        }
      } else {
        const CTUChecada = await verificarCTUChecada(cotaUsuarioId);
        if (CTUChecada) {
          const result = await atualizarCotaUsuario("AUTENTICADA_NIVEL1");
          if (result) {
            criandoTelaFinalizacao(cotaUsuarioId);
            setActiveStep(6);
          } else {
            error("Há algo de errado. VCP-088");
          }
        } else {
          const result = await atualizarCotaUsuario("AGUARDANDO_AUTENTICACAO");
          if (result) {
            criandoTelaFinalizacao(cotaUsuarioId);
            setActiveStep(6);
          } else {
            error("Há algo de errado. VCP-089");
          }
        }
      }
    } else {
      const CTUChecada = await verificarCTUChecada(cotaUsuarioId);
      if (CTUChecada) {
        const result = await atualizarCotaUsuario("AUTENTICADA_NIVEL1");
        if (result) {
          criandoTelaFinalizacao(cotaUsuarioId);
          setActiveStep(6);
        } else {
          error("Há algo de errado. VCP-086");
        }
      } else {
        const result = await atualizarCotaUsuario("AGUARDANDO_AUTENTICACAO");
        if (result) {
          criandoTelaFinalizacao(cotaUsuarioId);
          setActiveStep(6);
        } else {
          error("Há algo de errado. VCP-087");
        }
      }
    }
  };

  const isCampoVazio = () => {
    const propriedade = formApartamento.getFieldValue("propriedade");

    console.log("propriedade");
    console.log(propriedade);

    // Verifica se o objeto "propriedade" existe

    // Verifica se o objeto "propriedade" e o campo "nome" existem e se "nome" está vazio
    return !propriedade || !propriedade.capacidade;
  };

  //renderApSteps === 0 - De qual empreendimento é sua propriedade?
  //renderApSteps === 1 e !apCriadoPeloUsuario - Selecione seu apartamento
  //renderApSteps === 3 e !apCriadoPeloUsuario - Mias informações do apartamento

  //renderEmpSteps === 1 - Mensagem - Cadastre o empreendimento e mais informações a seguir
  //renderEmpSteps === 2 - Conte-me mais sobre o empreendimento
  //renderEmpSteps === 3  - Conte-me mais sobre o apartamento

  //renderProprietario === 0 - Sobre a titularidade da propriedade
  //renderProprietario === 1 - Mensagem faremos uma procuração
  //renderProprietario === 2 - Favor atualizar seu cadastro
  //renderProprietario === 3 - Favor informar dados do proprietário:
  //renderProprietario === 4 - Incluir comprovante da propriedade

  // Função principal que faz passar para o proxima etapa do componente STEPS
  const handleNext = async () => {
    switch (activeStep) {
      case 0:
        switch (renderApSteps) {
          case 0:
            if (empreedimentoSelecionado) {
              origemEmpRef.current = 0;
              // Caso já exista cota de usuario criada
              if (cotaUsuarioId !== 0) {
                // Antes de ir para proxima tela ele verifica se teve mudança
                if (changing.current) {
                  // aqui ele mudou para outro empreendimento do sistema
                  formApartamento.resetFields();
                  setApCriadoPeloUsuario(false);

                  setBloquearBotaoProximo(true);

                  changing.current = false;

                  setRenderApSteps(1);
                } else {
                  const vazio = isCampoVazio();

                  if (!vazio || apCriadoPeloUsuario) {
                    setBloquearBotaoProximo(false); // Não bloquear caso já tenha sido preenchido
                  } else {
                    setBloquearBotaoProximo(true); // Bloquear caso esteja incompleto
                  }

                  setRenderApSteps(1);
                }
              } else {
                // Verifica se os campos obrigatórios já foram preenchidos

                const vazio = isCampoVazio();

                if (!vazio || apCriadoPeloUsuario) {
                  setBloquearBotaoProximo(false); // Não bloquear caso já tenha sido preenchido
                } else {
                  setBloquearBotaoProximo(true); // Bloquear caso esteja incompleto
                }

                setRenderApSteps(1);
              }
            } else {
              setNaoEncontrouEmpreendimento(true);

              if (changing.current) {
                setRenderEmpSteps(1);

                setRenderApSteps(0);
              } else {
                if (
                  formEmpreendimento.cidadeId === undefined ||
                  formEmpreendimento.estado === undefined ||
                  formEmpreendimento.pais === undefined ||
                  formEmpreendimento.nome === ""
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }

                setRenderEmpSteps(2);

                setRenderApSteps(0);
              }
            }

            break;

          case 1:
            console.log("renderApSteps 1");
            console.log("Saindo da tela ' Selecione seu apartamento'");

            if (apCriadoPeloUsuario) {
              // apartamento criado pelo usuario

              idEmpRef.current = empreedimentoSelecionado.id;

              if (cotaUsuarioId !== 0) {
                // a cotaUsuario já existe

                if (changing.current) {
                  if (origemApRef.current === 0) {
                    const sucessoApto = cadastrarNovoApartamento();

                    if (await sucessoApto) {
                      changing.current = false;

                      setFormAp((prevState) => ({
                        ...prevState,
                        nome: undefined,
                        capacidade: undefined,
                        quartos: undefined,
                        banheiros: undefined,
                        metragem: undefined,
                        varanda: undefined,
                        terreo: undefined,
                        vista: undefined,
                        estacionamento: undefined,
                        origem: undefined,
                      }));

                      console.log(
                        "Indo para tela ' Conte-me mais sobre seu apartmento'"
                      );
                      setRenderApSteps(100);
                      setRenderEmpSteps(3);
                      setBloquearBotaoProximo(true);
                    }
                  } else {
                    //tratar aqui

                    const formData = {
                      empreendId: idEmpRef.current,
                    };

                    const resultado = await atualizarApartamento(
                      idApRef.current,
                      formData
                    );
                    formAp.empreendId = idEmpRef.current;

                    if (resultado) {
                      changing.current = false;

                      setFormAp((prevState) => ({
                        ...prevState,
                        nome: undefined,
                        capacidade: undefined,
                        quartos: undefined,
                        banheiros: undefined,
                        metragem: undefined,
                        varanda: undefined,
                        terreo: undefined,
                        vista: undefined,
                        estacionamento: undefined,
                        origem: undefined,
                      }));

                      console.log(
                        "Indo para tela ' Conte-me mais sobre seu apartmento'"
                      );

                      //como está zerando os campos necessariamente terá que bloquear o botão próximo
                      setBloquearBotaoProximo(true);

                      setRenderApSteps(100);
                      setRenderEmpSteps(3);
                      console.log(
                        "Indo para tela ' Conte-me mais sobre seu apartmento'"
                      );
                    }
                  }
                } else {
                  //vai para a outra tela

                  if (
                    formAp.nome === null ||
                    formAp.capacidade === null ||
                    formAp.quartos === null ||
                    formAp.banheiros === null ||
                    formAp.varanda === null ||
                    formAp.estacionamento === null ||
                    formAp.terreo === null ||
                    formAp.nome === undefined ||
                    formAp.capacidade === undefined ||
                    formAp.quartos === undefined ||
                    formAp.banheiros === undefined ||
                    formAp.varanda === undefined ||
                    formAp.estacionamento === undefined ||
                    formAp.terreo === undefined
                  ) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }

                  console.log(
                    "Indo para tela ' Conte-me mais sobre seu apartmento'"
                  );
                  setRenderApSteps(100);
                  setRenderEmpSteps(3);
                }
              } else {
                //cria o empreendimento novo
                setBloquearBotaoProximo(true);

                const sucessoApto = cadastrarNovoApartamento();
                if (await sucessoApto) {
                  console.log(
                    "Indo para tela ' Conte-me mais sobre seu apartmento'"
                  );
                  setRenderApSteps(100);
                  setRenderEmpSteps(3);
                  if (
                    formAp.nome === null ||
                    formAp.capacidade === null ||
                    formAp.quartos === null ||
                    formAp.banheiros === null ||
                    formAp.varanda === null ||
                    formAp.estacionamento === null ||
                    formAp.terreo === null
                  ) {
                    setBloquearBotaoProximo(true);
                  }
                } else {
                  error("Há algo de errado. Código de erro: VCP-033.");
                }
              }

              // Passa para o proximo render
            } else {
              //apartamento do sistema

              // buscarMeuEmp(empreedimentoSelecionado.id);

              //se tiver editando ou não. Esse editando é ativado tiver na URL o id da cotaUsuario ou se ele já criou e voltou alguns passos
              if (cotaUsuarioId !== 0) {
                if (changing.current) {
                  const sucessoCota = await atualizarCotaUsuario(
                    "",
                    0,
                    "ALTERAR_COTAID"
                  );
                  if (sucessoCota) {
                    changing.current = false;
                    if (origemApRef.current !== 0) {
                      origemApRef.current = 0;
                    }
                    if (origemEmpRef.current === 0) {
                    } else {
                      cronogramaEmp.current = 2;
                    }
                    console.log(
                      "Indo para a tela 'Mais informações apartamento'"
                    );
                    const sucessoCotaUsuario = await atualizarCotaUsuario(
                      "AGUARDANDO_APTOMAISINFO"
                    );
                    if (sucessoCotaUsuario) {
                      setState("AGUARDANDO_MAISINFO");
                      setRenderApSteps(100);
                      setRenderApSteps(3);

                      setFormInfo((prevState) => ({
                        ...prevState,
                        numeroApto: undefined,
                        andar: undefined,
                        vista: undefined,
                        bloco: undefined,
                      }));
                      setBloquearBotaoProximo(true);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-024");
                    }
                  }
                } else {
                  console.log(
                    "Indo para a tela 'Mais informações apartamento'"
                  );
                  setRenderApSteps(100);
                  setRenderApSteps(3);
                  if (
                    formInfo.numeroApto === null ||
                    formInfo.andar === null ||
                    formInfo.vista === null
                  ) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }
                }
              } else {
                const sucessoCotaUsuario = await criarCotaUsuario(
                  "AGUARDANDO_APTOMAISINFO"
                );
                if (sucessoCotaUsuario) {
                  setState("AGUARDANDO_MAISINFO"); // DEFINE O STATUS PENDENTE
                  console.log(
                    "Indo para a tela 'Mais informações apartamento'"
                  );
                  setRenderApSteps(100);
                  setRenderApSteps(3);
                } else {
                  error("Ocorreu um erro ao avançar. Tente novamente.");
                }
              }
            }

            break;

          case 3:
            if (changing.current) {
              const statusCTU = buscarStatusCTU(cotaUsuarioId);

              if ((await statusCTU) === "AGUARDANDO_APTOMAISINFO") {
                const sucesso = await atualizarCotaUsuario(
                  "AGUARDANDO_TITULARIDADE"
                );
                if (sucesso) {
                  setState("AGUARDANDO_TITULARIDADE"); // DEFINE O STATUS PENDENTE

                  if (propriedadeRes === 0) {
                    setBloquearBotaoProximo(true);
                  }
                  setRenderProprietario(0);
                  setActiveStep(1); // PASSA PARA O PROXIMO PASSO
                } else {
                  error("Há algo de errado. Código erro: VCP-014");
                }
              } else {
                const sucesso = await atualizarCotaUsuario(
                  "",
                  0,
                  "ALTERAR_MAIS_INFO"
                );

                if (sucesso) {
                  changing.current = false;

                  if (propriedadeRes === 0) {
                    setBloquearBotaoProximo(true);
                  }
                  setRenderProprietario(0);
                  setActiveStep(1); // PASSA PARA O PROXIMO PASSO
                } else {
                  error("Há algo de errado. Código erro: VCP-002");
                }
              }
            } else {
              if (propriedadeRes === 0) {
                setBloquearBotaoProximo(true);
              } else {
                setBloquearBotaoProximo(false);
              }
              setRenderProprietario(0);
              setActiveStep(1);
            }

            break;
        }

        switch (renderEmpSteps) {
          case 1:
            // formApartamento.resetFields();
            formAtualizarEstadoEmpreendimento.resetFields();
            formEmpreendimento.nome = "";
            formEmpreendimento.pais = undefined;
            formEmpreendimento.estado = undefined;
            formEmpreendimento.cidadeId = undefined;

            changing.current = false;

            setBloquearBotaoProximo(true);
            setRenderEmpSteps(2); // passa para o proximo render

            break;
          case 2:
            verificarSeFormApartamentoProprietarioVazio();

            //se tiver editando ou não. Esse editando é ativado tiver na URL o id da cotaUsuario ou se ele já criou e voltou alguns passos
            if (cotaUsuarioId !== 0) {
              // a cotaUsuario já existe

              //Está editando o empreendimento
              if (changing.current) {
                if (origemMinhaCota === 0) {
                  const sucessoEmpreendimento =
                    await cadastrarOuAtualizarEmpreendimento();

                  if (sucessoEmpreendimento) {
                    changing.current = false;

                    document.location.reload();
                  }
                } else {
                  const sucessoEmpreendimento =
                    await cadastrarOuAtualizarEmpreendimento(true);

                  if (sucessoEmpreendimento) {
                    changing.current = false;

                    document.location.reload();
                  }
                }
              } else {
                //vai para a outra tela

                setRenderEmpSteps(3);
              }
            } else {
              //cria o empreendimento novo

              const sucesso = await cadastrarOuAtualizarEmpreendimento();
              if (sucesso) {
                setRenderEmpSteps(3);
              } else {
                error("Há algo de errado. Código de erro: VCP-030.");
              }
            }
            break;
          case 3:
            cronogramaEmp.current = 2;

            if (cotaUsuarioId !== 0) {
              // a cotaUsuario já existe
              //Está editando o empreendimento

              if (state === "AGUARDANDO_APTOMAISINFO") {
                setBloquearBotaoProximo(true);
              } else {
                setBloquearBotaoProximo(false);
              }

              if (changing.current) {
                const sucessoApto = await editarAP();
                if (sucessoApto) {
                  if (state === "AGUARDANDO_APTO") {
                    const sucessoCTU = atualizarCotaUsuario(
                      "AGUARDANDO_APTOMAISINFO"
                    );
                  }
                  changing.current = false;
                  setRenderEmpSteps(0);

                  setRenderApSteps(3);
                  if (
                    formInfo.numeroApto === null ||
                    formInfo.andar === null ||
                    formInfo.vista === null
                  ) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }
                } else {
                  error("Há algo de errado. Código de erro: VCP-095.");
                }
              } else {
                //vai para a outra tela
                setRenderEmpSteps(0);
                setRenderApSteps(3);
                if (
                  formInfo.numeroApto === null ||
                  formInfo.andar === null ||
                  formInfo.vista === null
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }
              }
            } else {
              //cria o empreendimento novo

              const sucesso = await cadastrarNovoApartamento();
              if (sucesso) {
                setRenderEmpSteps(0);
                setRenderApSteps(3);
                if (
                  formInfo.numeroApto === null ||
                  formInfo.andar === null ||
                  formInfo.vista === null
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }
              } else {
                error("Há algo de errado. Código de erro: VCP-029.");
              }
            }

            break;
          // case 4:
          //   if (changing.current) {
          //     const statusCTU = buscarStatusCTU(cotaUsuarioId);

          //     if ((await statusCTU) === "AGUARDANDO_APTOMAISINFO") {
          //       const sucesso = await atualizarCotaUsuario(
          //         "AGUARDANDO_TITULARIDADE"
          //       );
          //       if (sucesso) {
          //         setState("AGUARDANDO_TITULARIDADE"); // DEFINE O STATUS PENDENTE

          //         setBloquearBotaoProximo(true);

          //         setActiveStep((prevActiveStep) => prevActiveStep + 1); // PASSA PARA O PROXIMO PASSO
          //       } else {
          //         error("Há algo de errado. Código erro: VCP-014");
          //       }
          //     } else {
          //       const sucesso = await atualizarCotaUsuario(
          //         "",
          //         0,
          //         "ALTERAR_MAIS_INFO"
          //       );

          //       if (sucesso) {
          //         setBloquearBotaoProximo(true);

          //         setActiveStep((prevActiveStep) => prevActiveStep + 1); // PASSA PARA O PROXIMO PASSO
          //       } else {
          //         error("Há algo de errado. Código erro: VCP-002");
          //       }
          //     }
          //   } else {
          //     setBloquearBotaoProximo(false);

          //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
          //   }

          //   break;
        }
        // if (renderEmpSteps >= 0 && renderApSteps === 0) {

        // }

        break;

      case 1:
        switch (renderProprietario) {
          case 0:
            switch (propriedadeRes) {
              case 1:
                if (bloqueadoEdicao.current) {
                  setActiveStep(2);
                  switch (cronogramaEmp.current) {
                    case 0:
                      setRenderCotaSteps(0);
                      setRenderPrioridadeSteps(1);
                      break;
                    case 1:
                      setRenderCotaSteps(1);
                      setRenderPrioridadeSteps(0);
                      if (
                        formMinhaCotaOrigemProprietario.numeroCota ===
                          undefined ||
                        formMinhaCotaOrigemProprietario.numeroCota === 0
                      ) {
                        setBloquearBotaoProximo(true);
                      } else {
                        setBloquearBotaoProximo(false);
                      }
                      break;
                    case 2:
                      setRenderCotaSteps(0);
                      setRenderPrioridadeSteps(0);
                      if (cronogramaFixoOuPrioridade === 0) {
                        setBloquearBotaoProximo(true);
                      } else {
                        setBloquearBotaoProximo(false);
                      }
                      break;
                  }
                } else {
                  if (state === "AGUARDANDO_TITULARIDADE") {
                    setBloquearBotaoProximo(true);
                  }
                  if (changing.current || state === "AGUARDANDO_TITULARIDADE") {
                    if (
                      state === "AGUARDANDO_TITULARIDADE" ||
                      state === "AGUARDANDO_REPRESENTANTE"
                    ) {
                      const cotaUsuarioAtualizada = await atualizarCotaUsuario(
                        "AGUARDANDO_COMPROVANTE"
                      );
                      if (cotaUsuarioAtualizada) {
                        const resultado = await verificarSeTemArquivos(
                          cotaUsuarioId
                        );
                        if (resultado) {
                          setBloquearBotaoProximo(false);
                        } else {
                          setBloquearBotaoProximo(true);
                        }
                        setRenderProprietario(4);
                        setState("AGUARDANDO_COMPROVANTE");
                      } else {
                        error("Há algo de errado. Código de erro: VCP-003.");
                      }
                    } else {
                      const Token = validateToken();
                      if (Token) {
                        const sucesso = cadastrarUsuario(+Token.id);
                        if (await sucesso) {
                          const representantes =
                            await buscarTodosOsRepresentantesCotaUsuario(
                              cotaUsuarioId
                            );
                          let sucessoDeletar;
                          if (representantes) {
                            sucessoDeletar = await deletarRepresentante();
                          }

                          if (
                            !representantes ||
                            (representantes && sucessoDeletar)
                          ) {
                            const cotaUsuarioAtualizada =
                              await atualizarCotaUsuario(
                                "AGUARDANDO_COMPROVANTE"
                              );
                            if (cotaUsuarioAtualizada) {
                              const resultado = await verificarSeTemArquivos(
                                cotaUsuarioId
                              );
                              if (resultado) {
                                setBloquearBotaoProximo(false);
                              } else {
                                setBloquearBotaoProximo(true);
                              }
                              setRenderProprietario(4);
                              setState("AGUARDANDO_COMPROVANTE");
                            } else {
                              error(
                                "Há algo de errado. Código de erro: VCP-050."
                              );
                            }
                          } else {
                            error("Há algo de errado. Código de erro: VCP-049");
                          }
                        } else {
                          error("Há algo de errado. Código de erro: VCP-047");
                        }
                      } else {
                        document.location.href = "/login";
                      }
                    }
                  } else {
                    const resultado = await verificarSeTemArquivos(
                      cotaUsuarioId
                    );

                    if (resultado) {
                      setBloquearBotaoProximo(false);
                    } else {
                      setBloquearBotaoProximo(true);
                    }
                    setRenderProprietario(4);
                  }
                }
                break;
              case 2:
                if (changing.current || state === "AGUARDANDO_TITULARIDADE") {
                  const cotaUsuarioAtualizada = await atualizarCotaUsuario(
                    "AGUARDANDO_REPRESENTANTE"
                  );
                  if (cotaUsuarioAtualizada) {
                    setRenderProprietario(1);
                    setState("AGUARDANDO_REPRESENTANTE");
                  } else {
                    error("Há algo de errado. Código de erro: VCP-004.");
                  }
                } else {
                  setRenderProprietario(2);
                }
                break;
            }

            break;
          case 1:
            setRenderProprietario(2);
            if (
              formAtualizarCadastro.nacionalidade === undefined ||
              formAtualizarCadastro.cidadeId === undefined ||
              formAtualizarCadastro.rg === undefined ||
              formAtualizarCadastro.complemento === undefined ||
              formAtualizarCadastro.endereco === undefined ||
              formAtualizarCadastro.estadoCivil === undefined ||
              formAtualizarCadastro.estadoId === undefined
            ) {
              setBloquearBotaoProximo(true);
            }

            break;
          case 2:
            if (state === "AGUARDANDO_REPRESENTANTE") {
              setBloquearBotaoProximo(true);
              setFormCadastroProprietario((prevState) => ({
                ...prevState,
                endereco: undefined,
                complemento: undefined,
                estadoId: undefined,
                cidadeId: undefined,
                usuarioId: undefined,
                nome: undefined,
                sobrenome: undefined,
                email: undefined,
                cpf: undefined,
                celular: undefined,
                nacionalidade: undefined,
                paisId: undefined,
                estadoCivil: undefined,
              }));
            }

            if (changing.current) {
              changing.current = false;
              const sucesso = await atualizarDados("REPRESENTANTE");
              if (sucesso) {
                setRenderProprietario(3);
              } else {
                error("Há algo de errado. Código de erro: VCP-035.");
              }
            } else {
              setRenderProprietario(3);
            }

            break;
          case 3:
            if (changing.current) {
              if (
                formCadastroNovoProprietario.cpf &&
                validaCPF(formCadastroNovoProprietario.cpf)
              ) {
                if (
                  formCadastroNovoProprietario.email &&
                  validacaoEmail(formCadastroNovoProprietario.email)
                ) {
                  const usuarioIdProprietario = obterUsuarioIdCTU();

                  const usuarioIdLogado = validateToken()?.id;

                  if ((await usuarioIdProprietario) === usuarioIdLogado) {
                    const usuario = await buscarUsuario(String(usuarioIdLogado));

                    switch (usuario.resultado) {
                      case 0:
                        // não foi encontrado usuario. Criar outro usuario

                        const sucesso = await cadastrarProprietario();
                        if (sucesso) {
                          const resultado = await verificarSeTemArquivos(
                            cotaUsuarioId
                          );
                          if (resultado) {
                            setBloquearBotaoProximo(false);
                          } else {
                            setBloquearBotaoProximo(true);
                          }
                          setRenderProprietario(4);

                          setState("AGUARDANDO_COMPROVANTE");
                        } else {
                          error("Há algo de errado. Código de erro: VCP-042");
                        }

                        break;

                      case 1:
                        // foi encontrado usuario com mesmo CPF. vincular a ele

                        const sucessoPropExistente =
                          await cadastrarProprietario(usuario.id);
                        if (sucessoPropExistente) {
                          const resultado = await verificarSeTemArquivos(
                            cotaUsuarioId
                          );
                          if (resultado) {
                            setBloquearBotaoProximo(false);
                          } else {
                            setBloquearBotaoProximo(true);
                          }
                          setRenderProprietario(4);

                          setState("AGUARDANDO_COMPROVANTE");
                        } else {
                          error("Há algo de errado. Código de erro: VCP-091");
                        }
                        break;

                      case 2:
                        error(
                          "Já existe uma conta com esse e-mail, favor utilizar outro."
                        );
                        break;
                      // não foi encontrado usuario com mesmo CPF, mas o e-mail informado já está sendo usado por outro usuario. Avisar ao usuario cadastrante.
                      case 3:
                        error(
                          "O CPF incluido no formulário é o mesmo que você cadastrou como seu CPF. Inclua o CPF do proprietário"
                        );
                        break;
                      default:
                        error("Há algo de errado. Código de erro: VCP-045");
                        break;
                    }
                  } else {
                    const sucesso = await atualizarDados("PROPRIETARIO");

                    if (sucesso) {
                      const resultado = await verificarSeTemArquivos(
                        cotaUsuarioId
                      );
                      if (resultado) {
                        setBloquearBotaoProximo(false);
                      } else {
                        setBloquearBotaoProximo(true);
                      }
                      setRenderProprietario(4);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-043");
                    }
                  }
                } else {
                  error("E-mail inválido. Favor verificar.");
                }
              } else {
                error("CPF inválido. Favor verificar.");
              }
            } else {
              const resultado = await verificarSeTemArquivos(cotaUsuarioId);
              if (resultado) {
                setBloquearBotaoProximo(false);
              } else {
                setBloquearBotaoProximo(true);
              }
              setRenderProprietario(4);
            }

            break;
          case 4:
            //aqui
            console.log("cronogramaEmp.current");
            console.log(cronogramaEmp.current);
            if (changing.current) {
              if (state === "AGUARDANDO_COMPROVANTE") {
                const cotaAtualizada = await atualizarCotaUsuario(
                  "AGUARDANDO_COTA"
                );
                if (cotaAtualizada) {
                  switch (cronogramaEmp.current) {
                    case 0:
                      prioridadeRef.current = true;

                      setState("AGUARDANDO_COTA");

                      setRenderProprietario(100);
                      setActiveStep(2);
                      if (origemApRef.current !== 0) {
                        setRenderPrioridadeSteps(0);
                        setRenderCotaSteps(0);
                        if (cronogramaFixoOuPrioridade === 0) {
                          setBloquearBotaoProximo(true);
                        } else {
                          setBloquearBotaoProximo(false);
                        }
                      } else {
                        setRenderPrioridadeSteps(1);
                        setRenderCotaSteps(0);
                      }

                      break;
                    case 1:
                      const sucesso = await buscarCotas();
                      if (sucesso) {
                        buscarMeuArquivo();
                        cotaRef.current = true;

                        setState("AGUARDANDO_COTA");

                        setRenderProprietario(100);
                        if (origemApRef.current !== 0) {
                          setRenderPrioridadeSteps(0);
                          setRenderCotaSteps(0);
                          if (cronogramaFixoOuPrioridade === 0) {
                            setBloquearBotaoProximo(true);
                          } else {
                            setBloquearBotaoProximo(false);
                          }
                        } else {
                          setRenderPrioridadeSteps(0);
                          setRenderCotaSteps(1);
                          if (
                            formMinhaCota.numeroCota === null ||
                            formMinhaCota.numeroCota === 0
                          ) {
                            setBloquearBotaoProximo(true);
                          } else {
                            setBloquearBotaoProximo(false);
                          }
                        }

                        setActiveStep(2);
                      } else {
                        error("Há algo de errado. Código de erro: VCP-051");
                      }
                      break;
                    case 2:
                      setRenderProprietario(100);
                      setRenderPrioridadeSteps(0);
                      setRenderCotaSteps(0);

                      setActiveStep(2);
                      break;
                  }
                  setBloquearBotaoProximo(true);

                  //  }else{
                  //   error("Há algo de errado. Código de erro: VCP-047");
                  //  }
                } else {
                  error("Há algo de errado. Código de erro: VCP-052");
                }
              } else {
                switch (cronogramaEmp.current) {
                  case 0:
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(1);
                    setRenderCotaSteps(0);
                    setActiveStep(2);
                    break;
                  case 1:
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(1);
                    if (
                      formMinhaCota.numeroCota === null ||
                      formMinhaCota.numeroCota === 0
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                    setActiveStep(2);
                    break;
                  case 2:
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(0);
                    setActiveStep(2);
                    break;
                }
                if (state === "AGUARDANDO_COTA") {
                  setBloquearBotaoProximo(true);
                } else {
                  if (
                    formPrioridade.prioridade !== null ||
                    formMinhaCota.numeroCota !== null
                  ) {
                    setBloquearBotaoProximo(false);
                  } else {
                    setBloquearBotaoProximo(true);
                  }
                }
              }
            } else {
              switch (cronogramaEmp.current) {
                case 0:
                  setRenderProprietario(100);
                  setActiveStep(2);
                  if (origemApRef.current !== 0) {
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(0);
                    if (cronogramaFixoOuPrioridade === 0) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                  } else {
                    setRenderPrioridadeSteps(1);
                    setRenderCotaSteps(0);

                    if (
                      formPrioridade.prioridade === null ||
                      formPrioridade.prioridade === ""
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                  }

                  break;
                case 1:
                  setRenderProprietario(100);
                  if (origemApRef.current !== 0) {
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(0);
                    if (cronogramaFixoOuPrioridade === 0) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                  } else {
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(1);

                    if (
                      formMinhaCotaOrigemProprietario.numeroCota ===
                        undefined ||
                      formMinhaCotaOrigemProprietario.numeroCota === 0
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                  }

                  setActiveStep(2);

                  break;
                case 2:
                  setRenderProprietario(100);
                  setRenderPrioridadeSteps(0);
                  setRenderCotaSteps(0);
                  setActiveStep(2);
                  if (cronogramaFixoOuPrioridade === 0) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }

                  break;
              }
            }

            break;
        }
        break;
      case 2:
        switch (renderCotaSteps) {
          case 0:
            switch (renderPrioridadeSteps) {
              case 0:
                switch (cronogramaFixoOuPrioridade) {
                  case 1:
                    if (
                      formMinhaCotaOrigemProprietario.numeroCota ===
                        undefined ||
                      formMinhaCotaOrigemProprietario.numeroCota === 0 ||
                      formMinhaCotaOrigemProprietario.numeroCota === ""
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }

                    if (changing.current) {
                      const sucessoCTU =
                        atualizarCotaUsuario("AGUARDANDO_COTA");
                      const sucesso = atualizarMeuEmp(idEmpRef.current);
                      if ((await sucesso) && (await sucessoCTU)) {
                        setCronogramaFixoOuPrioridade(1);
                        cronogramaEmp.current = 2;

                        setRenderCotaSteps(1);
                        setRenderPrioridadeSteps(0);
                      }
                    } else {
                      setRenderCotaSteps(1);
                      setRenderPrioridadeSteps(0);
                    }
                    break;
                  case 2:
                    if (
                      formPrioridade.prioridade === null ||
                      formPrioridade.prioridade === 0 ||
                      formPrioridade.prioridade === ""
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }

                    if (changing.current) {
                      const sucessoCTU =
                        atualizarCotaUsuario("AGUARDANDO_COTA");
                      const sucesso = atualizarMeuEmp(idEmpRef.current);
                      if ((await sucesso) && (await sucessoCTU)) {
                        setCronogramaFixoOuPrioridade(2);
                        cronogramaEmp.current = 2;
                        setRenderCotaSteps(0);
                        setRenderPrioridadeSteps(1);
                      }
                    } else {
                      setRenderCotaSteps(0);
                      setRenderPrioridadeSteps(1);
                    }

                    break;
                }

                break;
              case 1:
                const tratamentoOrigemProprietario = async () => {
                  if (changing.current) {
                    const sucesso = await atualizarCotaUsuario();

                    if (sucesso) {
                      //indo para tela de quantas semanas
                      if (
                        formSemanasPorAno.semanasPorAno === null ||
                        formSemanasPorAno.semanasPorAno === 0 ||
                        formSemanasPorAno.semanasPorAno === ""
                      ) {
                        setBloquearBotaoProximo(true); //
                      } else {
                        setBloquearBotaoProximo(false);
                      }
                      setRenderPrioridadeSteps(2);
                      setRenderCotaSteps(0);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-062");
                    }
                  } else {
                    //indo para tela de quantas semanas
                    if (
                      formSemanasPorAno.semanasPorAno === null ||
                      formSemanasPorAno.semanasPorAno === 0 ||
                      formSemanasPorAno.semanasPorAno === ""
                    ) {
                      setBloquearBotaoProximo(true); //
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                    setRenderPrioridadeSteps(2);
                    setRenderCotaSteps(0);
                  }
                };
                switch (cronogramaEmp.current) {
                  case 0:
                    if (origemApRef.current === 0) {
                      if (changing.current) {
                        let sucesso;
                        if (state === "AGUARDANDO_COTA") {
                          sucesso = await atualizarCotaUsuario(
                            "AGUARDANDO_DEFINICAO_ANUNCIO"
                          );

                          setAnunciar(1);
                        } else {
                          sucesso = await atualizarCotaUsuario();
                        }

                        if (sucesso) {
                          telaDePagamento();
                        } else {
                          error("Há algo de errado. Código de erro: VCP-069");
                        }
                      } else {
                        telaDePagamento();
                      }
                    } else {
                      tratamentoOrigemProprietario();
                    }

                    break;
                  case 2:
                    tratamentoOrigemProprietario();

                    break;
                }

                break;

              case 2:
                if (
                  formDiaDaSemana.diaDaSemana === null ||
                  formDiaDaSemana.diaDaSemana === 0 ||
                  formDiaDaSemana.diaDaSemana === ""
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }
                if (changing.current) {
                  const sucesso = await atualizarMinhaCota(
                    "atualizarQtdSemanas"
                  );
                  if (sucesso) {
                    //indo para tela de quantas semanas

                    setRenderPrioridadeSteps(3);
                    setRenderCotaSteps(0);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-066");
                  }
                } else {
                  //indo para tela de quantas semanas
                  setRenderPrioridadeSteps(3);
                  setRenderCotaSteps(0);
                }
                break;
              case 3:
                if (changing.current) {
                  const sucesso = await atualizarMinhaCota(
                    "atualizarDiaSemana"
                  );
                  if (sucesso) {
                    //indo para tela de pagamentos
                    changing.current = false;
                    let sucessoCTU;
                    if (state === "AGUARDANDO_COTA") {
                      sucessoCTU = await atualizarCotaUsuario(
                        "AGUARDANDO_DEFINICAO_ANUNCIO"
                      );
                      if (sucessoCTU) {
                        setAnunciar(1);
                        setRenderCotaSteps(0);
                        setRenderPrioridadeSteps(0);
                        if (cronogramaFixoOuPrioridade === 0) {
                          setBloquearBotaoProximo(true);
                        } else {
                          setBloquearBotaoProximo(false);
                        }
                        telaDePagamento();
                      } else {
                        error("Há algo de errado. Código de erro: VCP-067");
                      }
                    } else {
                      setAnunciar(1);
                      setRenderCotaSteps(0);
                      setRenderPrioridadeSteps(0);
                      if (cronogramaFixoOuPrioridade === 0) {
                        setBloquearBotaoProximo(true);
                      } else {
                        setBloquearBotaoProximo(false);
                      }
                      telaDePagamento();
                    }
                  } else {
                    error("Há algo de errado. Código de erro: VCP-068");
                  }
                } else {
                  //indo para tela de pagamentos
                  setAnunciar(1);
                  setRenderCotaSteps(0);
                  setRenderPrioridadeSteps(0);
                  if (cronogramaFixoOuPrioridade === 0) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }
                  telaDePagamento();
                }
                break;
            }

            break;
          case 1:
            switch (cronogramaEmp.current) {
              case 1:
                if (changing.current) {
                  if (origemApRef.current === 0) {
                    let sucesso;
                    if (state === "AGUARDANDO_COTA") {
                      sucesso = await atualizarCotaUsuario(
                        "AGUARDANDO_DEFINICAO_ANUNCIO"
                      );

                      setAnunciar(1);
                    } else {
                      // Atualiza a cota usuário passando o tipo e a cotaId que será atualizada
                      sucesso = await atualizarCotaUsuario(
                        undefined,
                        undefined,
                        "ALTERAR_COTAID",
                        formMinhaCotaOrigemProprietario.numeroCota ?? undefined
                      );
                    }

                    if (sucesso) {
                      if (origemApRef.current === 0) {
                        telaDePagamento();
                      } else {
                        const sucesso = await atualizarMinhaCota(
                          "atualizarNumeroCota"
                        );
                        if (sucesso) {
                          //indo para tela de quantas semanas
                          if (
                            formSemanasPorAno.semanasPorAno === null ||
                            formSemanasPorAno.semanasPorAno === 0
                          ) {
                            setBloquearBotaoProximo(true); //
                          } else {
                            setBloquearBotaoProximo(false);
                          }
                          setRenderPrioridadeSteps(2);
                          setRenderCotaSteps(0);
                        } else {
                          error("Há algo de errado. Código de erro: VCP-062");
                        }
                      }
                    } else {
                      error("Há algo de errado. Código de erro: VCP-053");
                    }
                  } else {
                    if (changing.current) {
                      const sucesso = await atualizarMinhaCota(
                        "atualizarNumeroCota"
                      );
                      if (sucesso) {
                        //indo para tela de quantas semanas
                        if (
                          formSemanasPorAno.semanasPorAno === null ||
                          formSemanasPorAno.semanasPorAno === 0
                        ) {
                          setBloquearBotaoProximo(true); //
                        } else {
                          setBloquearBotaoProximo(false);
                        }
                        setRenderPrioridadeSteps(2);
                        setRenderCotaSteps(0);
                      } else {
                        error("Há algo de errado. Código de erro: VCP-062");
                      }
                    } else {
                      //indo para tela de quantas semanas

                      setRenderPrioridadeSteps(2);
                      setRenderCotaSteps(0);
                    }
                  }
                } else {
                  if (origemApRef.current === 0) {
                    telaDePagamento();
                  } else {
                    setRenderPrioridadeSteps(2);
                    setRenderCotaSteps(0);
                  }
                }

                break;
              case 2:
                if (changing.current) {
                  const sucesso = await atualizarMinhaCota(
                    "atualizarNumeroCota"
                  );
                  if (sucesso) {
                    //indo para tela de quantas semanas
                    if (
                      formSemanasPorAno.semanasPorAno === null ||
                      formSemanasPorAno.semanasPorAno === 0
                    ) {
                      setBloquearBotaoProximo(true); //
                    } else {
                      setBloquearBotaoProximo(false);
                    }
                    setRenderPrioridadeSteps(2);
                    setRenderCotaSteps(0);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-062");
                  }
                } else {
                  //indo para tela de quantas semanas

                  setRenderPrioridadeSteps(2);
                  setRenderCotaSteps(0);
                }

                break;
            }

            break;
        }

        break;
      case 3:
        switch (renderPagamentoSteps) {
          case 1:
            switch (anunciar) {
              case 1:
                const resultPagamento = await verificarPagamentoPorStatus(
                  "ATIVA",
                  cotaUsuarioId
                );
                if (resultPagamento) {
                  setRenderPagamentoSteps(2);
                } else {
                  const resultPagamentoPendente =
                    await verificarPagamentoPorStatus(
                      "PENDENTE",
                      cotaUsuarioId
                    );
                  if (resultPagamentoPendente) {
                    setRenderPagamentoSteps(2);
                  } else {
                    const formData = {
                      usuarioId: usuarioLogadoId,
                      cotasUsuariosId: cotaUsuarioId,
                      planoAssinatura: "ANUNCIO_PROPRIEDADE",
                    };

                    const resultadoAssinatura = criarAssinaturaCTU(formData);

                    if (await resultadoAssinatura) {
                      const resultMaisInfo =
                        await verificarSeMaisInformacoesAnuncioEstaoAusentes(
                          cotaUsuarioId
                        );
                      if (resultMaisInfo) {
                        const resultadoAtualizarCTU = atualizarCotaUsuario(
                          "AGUARDANDO_MAISINFO_ANUNCIO"
                        );
                        if (await resultadoAtualizarCTU) {
                          setRenderPagamentoSteps(2);
                          document.location.href = `${Globais.LINK_PAGAMENTO}`;
                        } else {
                          error("Há algo de errado. VCP-081");
                        }
                      } else {
                        //_______________________________________
                        let sucesso;
                        switch (cronogramaEmp.current) {
                          case 0:
                            const periodosDefinidos =
                              verificarSeTemPeriodoUsuarioDefinido(
                                cotaUsuarioId
                              );
                            if (await periodosDefinidos) {
                              setActiveStep(6);
                            } else {
                              const temPeriodos =
                                await verificarSeTemPeriodoUsuario(
                                  cotaUsuarioId
                                );
                              if (temPeriodos) {
                                sucesso = atualizarCotaUsuario(
                                  "AGUARDANDO_DEFINICAO_PERIODOS"
                                );
                                if (await sucesso) {
                                  changing.current = false;
                                  //indo para mensagem de desistencia pagamento
                                  setActiveStep(5);
                                  setRenderAdicionarPeriodo(3);
                                } else {
                                  error(
                                    "Há algo de errado. Código de erro: VCP-074"
                                  );
                                }
                              } else {
                                sucesso = atualizarCotaUsuario(
                                  "AGUARDANDO_PERIODOS"
                                );
                                if (await sucesso) {
                                  changing.current = false;
                                  //indo para mensagem de desistencia pagamento
                                  setActiveStep(4);
                                  setRenderAdicionarPeriodo(1);
                                } else {
                                  error(
                                    "Há algo de errado. Código de erro: VCP-073"
                                  );
                                }
                              }
                            }

                            break;
                          case 1:
                            const periodosDefinidosCase1 =
                              verificarSeTemPeriodoUsuarioDefinido(
                                cotaUsuarioId
                              );
                            if (await periodosDefinidosCase1) {
                              setActiveStep(6);
                            } else {
                              sucesso = atualizarCotaUsuario(
                                "AGUARDANDO_DEFINICAO_PERIODOS"
                              );
                              if (await sucesso) {
                                changing.current = false;
                                //indo para mensagem de desistencia pagamento
                                setActiveStep(5);
                                setRenderAdicionarPeriodo(3);
                              } else {
                                error(
                                  "Há algo de errado. Código de erro: VCP-074"
                                );
                              }
                            }

                            break;

                          case 2:
                            const periodosDefinidosCase2 =
                              verificarSeTemPeriodoUsuarioDefinido(
                                cotaUsuarioId
                              );
                            if (await periodosDefinidosCase2) {
                              setActiveStep(6);
                            } else {
                              const temPeriodos =
                                await verificarSeTemPeriodoUsuario(
                                  cotaUsuarioId
                                );
                              if (temPeriodos) {
                                sucesso = atualizarCotaUsuario(
                                  "AGUARDANDO_DEFINICAO_PERIODOS"
                                );
                                if (await sucesso) {
                                  changing.current = false;
                                  //indo para mensagem de desistencia pagamento
                                  setActiveStep(5);
                                  setRenderAdicionarPeriodo(3);
                                } else {
                                  error(
                                    "Há algo de errado. Código de erro: VCP-074"
                                  );
                                }
                              } else {
                                sucesso = atualizarCotaUsuario(
                                  "AGUARDANDO_PERIODOS"
                                );
                                if (await sucesso) {
                                  changing.current = false;
                                  //indo para mensagem de desistencia pagamento
                                  setActiveStep(4);
                                  setRenderAdicionarPeriodo(2);
                                } else {
                                  error(
                                    "Há algo de errado. Código de erro: VCP-075"
                                  );
                                }
                              }
                            }

                            break;
                        }

                        setRenderPagamentoSteps(2);
                        document.location.href = `${Globais.LINK_PAGAMENTO}`;

                        //_____________________________
                      }
                    } else {
                      error("Há algo de errado. VCP-080");
                      return false;
                    }
                  }
                }

                break;
              case 2:
                setActiveStep(3);
                setRenderPagamentoSteps(3);

                break;
            }
            break;
          case 2:
            setBloquearBotaoProximo(false);

            let sucesso;
            switch (cronogramaEmp.current) {
              case 0:
                const resultadoDefinido =
                  verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                if (await resultadoDefinido) {
                  regularizarCTUAguardandoMaisInfoAnuncio();
                } else {
                  const resultadoTemPeriodo =
                    verificarSeTemPeriodoUsuario(cotaUsuarioId);
                  if (await resultadoTemPeriodo) {
                    sucesso = atualizarCotaUsuario(
                      "AGUARDANDO_DEFINICAO_PERIODOS"
                    );
                    if (await sucesso) {
                      changing.current = false;

                      setActiveStep(5);
                      setRenderAdicionarPeriodo(4);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-082");
                    }
                  } else {
                    sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                    if (await sucesso) {
                      changing.current = false;
                      //indo para mensagem de desistencia pagamento
                      setActiveStep(4);
                      setRenderAdicionarPeriodo(1);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-073");
                    }
                  }
                }

                break;

              case 1:
                const resultadoDefinidoEmpCase1 =
                  verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                if (await resultadoDefinidoEmpCase1) {
                  regularizarCTUAguardandoMaisInfoAnuncio();
                } else {
                  sucesso = atualizarCotaUsuario(
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                  );
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(3);
                  } else {
                    error("Há algo de errado. Código de erro: VCP-083");
                  }
                }

                break;
              case 2:
                const resultadoDefinidoEmp2 =
                  verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                if (await resultadoDefinidoEmp2) {
                  regularizarCTUAguardandoMaisInfoAnuncio();
                } else {
                  const resultadoTemPeriodo =
                    verificarSeTemPeriodoUsuario(cotaUsuarioId);
                  if (await resultadoTemPeriodo) {
                    sucesso = atualizarCotaUsuario(
                      "AGUARDANDO_DEFINICAO_PERIODOS"
                    );
                    if (await sucesso) {
                      changing.current = false;

                      setActiveStep(5);
                      setRenderAdicionarPeriodo(4);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-083");
                    }
                  } else {
                    sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                    if (await sucesso) {
                      changing.current = false;

                      setActiveStep(4);
                      setRenderAdicionarPeriodo(2);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-075");
                    }
                  }
                }

                break;
            }

            break;

          case 3:
            if (changing.current) {
              setBloquearBotaoProximo(false);

              let sucesso;

              switch (cronogramaEmp.current) {
                case 0:
                  const periodosDefinidos =
                    verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                  if (await periodosDefinidos) {
                    setActiveStep(6);
                  } else {
                    const temPeriodos = await verificarSeTemPeriodoUsuario(
                      cotaUsuarioId
                    );
                    if (temPeriodos) {
                      sucesso = atualizarCotaUsuario(
                        "AGUARDANDO_DEFINICAO_PERIODOS"
                      );
                      if (await sucesso) {
                        changing.current = false;
                        //indo para mensagem de desistencia pagamento
                        setActiveStep(5);
                        setRenderAdicionarPeriodo(3);
                      } else {
                        error("Há algo de errado. Código de erro: VCP-074");
                      }
                    } else {
                      sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                      if (await sucesso) {
                        changing.current = false;
                        //indo para mensagem de desistencia pagamento
                        setActiveStep(4);
                        setRenderAdicionarPeriodo(1);
                      } else {
                        error("Há algo de errado. Código de erro: VCP-073");
                      }
                    }
                  }

                  break;
                case 1:
                  const periodosDefinidosCase1 =
                    verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                  if (await periodosDefinidosCase1) {
                    if (state === "AGUARDANDO_MAISINFO_ANUNCIO") {
                      regularizarCTUAguardandoMaisInfoAnuncio();
                    } else {
                      criandoTelaFinalizacao(cotaUsuarioId);
                      setActiveStep(6);
                    }
                  } else {
                    sucesso = atualizarCotaUsuario(
                      "AGUARDANDO_DEFINICAO_PERIODOS"
                    );
                    if (await sucesso) {
                      changing.current = false;
                      //indo para mensagem de desistencia pagamento
                      setActiveStep(5);
                      setRenderAdicionarPeriodo(3);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-074");
                    }
                  }

                  break;

                case 2:
                  const periodosDefinidosCase2 =
                    verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                  if (await periodosDefinidosCase2) {
                    if (state === "AGUARDANDO_MAISINFO_ANUNCIO") {
                      regularizarCTUAguardandoMaisInfoAnuncio();
                    } else {
                      setActiveStep(6);
                    }
                  } else {
                    const temPeriodos = await verificarSeTemPeriodoUsuario(
                      cotaUsuarioId
                    );
                    if (temPeriodos) {
                      sucesso = atualizarCotaUsuario(
                        "AGUARDANDO_DEFINICAO_PERIODOS"
                      );
                      if (await sucesso) {
                        changing.current = false;
                        //indo para mensagem de desistencia pagamento
                        setActiveStep(5);
                        setRenderAdicionarPeriodo(3);
                      } else {
                        error("Há algo de errado. Código de erro: VCP-074");
                      }
                    } else {
                      sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                      if (await sucesso) {
                        changing.current = false;
                        //indo para mensagem de desistencia pagamento
                        setActiveStep(4);
                        setRenderAdicionarPeriodo(2);
                      } else {
                        error("Há algo de errado. Código de erro: VCP-075");
                      }
                    }
                  }

                  break;
              }
            } else {
              switch (cronogramaEmp.current) {
                case 0:
                  const periodosDefinidos =
                    verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                  if (await periodosDefinidos) {
                    setActiveStep(6);
                  } else {
                    const temPeriodos = await verificarSeTemPeriodoUsuario(
                      cotaUsuarioId
                    );
                    if (temPeriodos) {
                      setActiveStep(5);
                      setRenderAdicionarPeriodo(4);
                    } else {
                      if (origemApRef.current !== 0) {
                        setActiveStep(4);
                        setRenderAdicionarPeriodo(2);
                      } else {
                        setActiveStep(4);
                        setRenderAdicionarPeriodo(1);
                      }
                    }
                  }

                  break;
                case 1:
                  const periodosDefinidosCase1 =
                    verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                  if (await periodosDefinidosCase1) {
                    setActiveStep(6);
                  } else {
                    if (origemApRef.current !== 0) {
                      const temPeriodos = await verificarSeTemPeriodoUsuario(
                        cotaUsuarioId
                      );
                      if (temPeriodos) {
                        setActiveStep(5);
                        setRenderAdicionarPeriodo(4);
                      } else {
                        setActiveStep(4);
                        setRenderAdicionarPeriodo(2);
                      }
                    } else {
                      setActiveStep(5);
                      setRenderAdicionarPeriodo(3);
                    }
                  }

                  break;

                case 2:
                  const periodosDefinidosCase2 =
                    verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
                  if (await periodosDefinidosCase2) {
                    setActiveStep(6);
                  } else {
                    const temPeriodos = await verificarSeTemPeriodoUsuario(
                      cotaUsuarioId
                    );
                    if (temPeriodos) {
                      setActiveStep(5);
                      setRenderAdicionarPeriodo(4);
                    } else {
                      setActiveStep(4);
                      setRenderAdicionarPeriodo(2);
                    }
                  }

                  break;
              }
            }

            break;
          case 3:
            break;
        }
        break;
      case 4:
        switch (renderAdicionarPeriodo) {
          case 1:
            navigate(`/adicionarPeriodos?cotaUsuarioId=${cotaUsuarioId}`);
            break;
          case 2:
            navigate(
              `/disponibilizacaoPeriodos?cotaUsuarioId=${cotaUsuarioId}`
            );
            break;
        }
        break;
      case 5:
        navigate(`/disponibilizacaoPeriodos?cotaUsuarioId=${cotaUsuarioId}`);
        break;
      case 6:
        navigate(`/cadastroCotas`);
        window.scrollTo(0, 0);

        break;
    }
  };

  // Função principal que volta a etapa do componente STEPS
  const handleBack = async () => {
    changing.current = false;
    setBloquearBotaoProximo(false);

    switch (activeStep) {
      case 0:
        switch (renderApSteps) {
          case 1:
            setRenderApSteps(0);
            break;

          case 3:
            setBloquearBotaoProximo(false);

            if (origemApRef.current !== 0) {
              setRenderEmpSteps(3);
              setRenderApSteps(0);
            } else {
              setRenderApSteps(1);
            }

            break;
        }

        switch (renderEmpSteps) {
          case 1:
            setRenderApSteps(0);
            setRenderEmpSteps(0);

            break;
          case 2:
            setRenderApSteps(0);
            setRenderEmpSteps(0);

            break;
          case 3:
            if (origemEmpRef.current === 0) {
              setRenderEmpSteps(0);
              setRenderApSteps(1);

              setApCriadoPeloUsuario(true);
            } else {
              setRenderApSteps(100);
              setRenderEmpSteps(2);
            }

            break;
          case 4:
            setRenderEmpSteps(renderEmpSteps - 1);

            break;
        }

        break;
      case 1:
        switch (renderProprietario) {
          case 0:
            setActiveStep(0);
            setRenderApSteps(3);

            break;
          case 1:
            setRenderProprietario(0);

            break;
          case 2:
            setRenderProprietario(0);

            break;
          case 3:
            setRenderProprietario(2);

            break;
          case 4:
            if (propriedadeRes === 1) {
              setRenderProprietario(0);
            } else {
              if (propriedadeRes === 2) {
                setRenderProprietario(3);
              } else {
                error("Há algo de errado. Código de erro: VCP-040");
              }
            }

            break;
        }
        break;
      case 2:
        switch (renderCotaSteps) {
          case 0:
            switch (renderPrioridadeSteps) {
              case 0:
                buscarMeuArquivo();
                setActiveStep(1);
                setRenderProprietario(4);

                break;
              case 1:
                switch (cronogramaEmp.current) {
                  case 0:
                    //indo para  tela incluir comprovante
                    if (origemApRef.current === 0) {
                      setRenderProprietario(4);
                      setActiveStep(1);
                    } else {
                      setRenderCotaSteps(0);
                      setRenderPrioridadeSteps(0);
                    }
                    break;

                  case 2:
                    //volta para a tela Como são definidos seus períodos
                    setRenderCotaSteps(0);
                    setRenderPrioridadeSteps(0);
                    if (cronogramaFixoOuPrioridade === 0) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }

                    break;
                }

                break;
              case 2:
                switch (cronogramaFixoOuPrioridade) {
                  case 1:
                    setRenderCotaSteps(1);
                    setRenderPrioridadeSteps(0);

                    if (
                      formMinhaCotaOrigemProprietario.numeroCota ===
                        undefined ||
                      formMinhaCotaOrigemProprietario.numeroCota === 0
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      setBloquearBotaoProximo(false);
                    }

                    break;
                  case 2:
                    setRenderCotaSteps(0);
                    setRenderPrioridadeSteps(renderPrioridadeSteps - 1);

                    break;
                }

                break;
              case 3:
                setRenderCotaSteps(0);
                setRenderPrioridadeSteps(renderPrioridadeSteps - 1);

                break;
            }
            break;
          case 1:
            switch (cronogramaEmp.current) {
              case 1:
                //indo para  tela incluir comprovante

                if (origemApRef.current !== 0) {
                  setRenderCotaSteps(0);
                  setRenderPrioridadeSteps(0);
                  if (cronogramaFixoOuPrioridade === 0) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }
                } else {
                  setActiveStep(1);
                  if (propriedadeRes === 1) {
                    setRenderProprietario(0);
                  } else {
                    if (propriedadeRes === 2) {
                      setRenderProprietario(3);
                    } else {
                      error("Há algo de errado. Código de erro: VCP-040");
                    }
                  }
                }

                break;
              case 2:
                //volta para a tela Como são definidos seus períodos

                setRenderCotaSteps(0);
                setRenderPrioridadeSteps(0);
                if (cronogramaFixoOuPrioridade === 0) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }
                break;
            }
            break;
        }

        break;
      case 3:
        switch (renderPagamentoSteps) {
          case 1:
            switch (cronogramaEmp.current) {
              case 0:
                setRenderProprietario(100);
                if (origemApRef.current !== 0) {
                  setRenderPrioridadeSteps(3);
                  setRenderCotaSteps(0);
                } else {
                  setRenderPrioridadeSteps(1);
                  setRenderCotaSteps(0);
                }

                setActiveStep(2);
                break;
              case 1:
                buscarCotas();
                setRenderProprietario(100);
                if (origemApRef.current !== 0) {
                  setRenderPrioridadeSteps(3);
                  setRenderCotaSteps(0);
                } else {
                  setRenderPrioridadeSteps(0);
                  setRenderCotaSteps(1);
                }

                if (
                  formMinhaCota.numeroCota === null ||
                  formMinhaCota.numeroCota === 0
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }
                setActiveStep(2);
                break;
              case 2:
                setRenderProprietario(100);
                setRenderPrioridadeSteps(3);
                setRenderCotaSteps(0);
                setActiveStep(2);
                break;
            }
            break;
          case 2:
            switch (cronogramaEmp.current) {
              case 0:
                setRenderProprietario(100);
                setRenderPrioridadeSteps(1);
                setRenderCotaSteps(0);
                setActiveStep(2);
                break;
              case 1:
                buscarCotas();
                setRenderProprietario(100);
                setRenderPrioridadeSteps(0);
                setRenderCotaSteps(1);
                if (
                  formMinhaCota.numeroCota === null ||
                  formMinhaCota.numeroCota === 0
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }
                setActiveStep(2);
                break;
              case 2:
                setRenderProprietario(100);
                setRenderPrioridadeSteps(3);
                setRenderCotaSteps(0);
                setActiveStep(2);
                break;
            }

            break;
          case 3:
            changing.current = false;
            setRenderPagamentoSteps(1);
            break;
        }

        break;
      case 4:
        setActiveStep(activeStep - 1);

        break;
      case 5:
        const pagamentosPendentes = await verificarPagamentoPorStatus(
          "PENDENTE",
          cotaUsuarioId
        );
        const pagamentosAtivos = await verificarPagamentoPorStatus(
          "ATIVA",
          cotaUsuarioId
        );
        if (pagamentosPendentes || pagamentosAtivos) {
          setActiveStep(3);
          setRenderPagamentoSteps(2);
        } else {
          setActiveStep(3);
          setRenderPagamentoSteps(1);
        }

        break;
      case 6:
        switch (anunciar) {
          case 1:
            setActiveStep(3);
            setRenderPagamentoSteps(2);

            break;
          case 2:
            setActiveStep(3);
            setRenderPagamentoSteps(1);
            break;
        }

        break;
    }
  };

  const propriedadeChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setBloquearBotaoProximo(false);

    setPropriedadeRes(e.target.value);
  };

  const cronogramaFixoOuPrioridadeChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setBloquearBotaoProximo(false);

    setCronogramaFixoOuPrioridade(e.target.value);
  };

  //Função que armazena no state o estado selecionado
  const handleEstadoChange = (value: number, formAtualizar: any) => {
    changing.current = true;

    setSelectedEstado(value);

    formAtualizar.setFieldsValue({ cidadeId: undefined }); // Limpa o valor da cidade no formulário específico

    setCidades([]);
  };

  //Função que armazena no state e filtra de acordo com id o empreendimento selecionado Etapa: De qual empreendimento é sua propriedade?
  const handleSelectChange = (value: number) => {
    console.log("ta vindo aqui");
    const selectedEmp = empreendimento.find(
      (emp: Empreendimento) => emp.id === value
    );

    if (selectedEmp) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      setEmpreendimentoSelecionadoAp(null);
      setEmpreendimentoSelecionado(selectedEmp);
      if (selectedEmp.cronograma) {
        cronogramaEmp.current = selectedEmp.cronograma;
      }
    } else {
      // Lidar com o caso onde nenhum empreendimento foi encontrado
      console.error("Erro, por favor entre em contato");
    }
  };

  //Função que armazena no state se o empreendimento foi encontrado ou não
  // TRUE - empreendimento não encontrado
  // FALSE - empreendimento encontrado
  const naoEncontradoChange: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      setNaoEncontrouEmpreendimento(true);
      setEmpreendimentoNaoSelecionado(true);
      setEmpreendimentoSelecionado(null);
    } else {
      setNaoEncontrouEmpreendimento(false);
      setBloquearBotaoProximo(true);
      setEmpreendimentoNaoSelecionado(false);
    }
  };

  //Função que armazena no state e filtra de acordo com id do apartamento selecionado
  const handleEmpreendimentoApChange = (value: number) => {
    const selectedEmp = empreendimentoAp.find(
      (emp: ApData) => emp.id === value
    );
    if (selectedEmp) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      setEmpreendimentoSelecionadoAp(selectedEmp);
      setOrigemAp(selectedEmp.origem);
    } else {
      console.error("Erro, por favor entre em contato");
    }
  };

  //Função que reseta o formulario caso o apartamento nao tenha sido encontrado
  // TRUE - apartamento não encontrado
  // FALSE - apartamento encontrado

  const naoEncontradoAp: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      formApartamento.resetFields();
      setApCriadoPeloUsuario(true);
      setEmpreendimentoSelecionadoAp(null);
      formApartamento.setFields([
        { name: ["propriedade", "nomeAp"], value: undefined },
        {
          name: ["propriedade", "capacidade"],
          value: undefined,
        },
        { name: ["propriedade", "quartos"], value: undefined },
        {
          name: ["propriedade", "banheiros"],
          value: undefined,
        },
        { name: ["propriedade", "metragem"], value: undefined },
        { name: ["propriedade", "varanda"], value: undefined },
        { name: ["propriedade", "terreo"], value: undefined },
        {
          name: ["propriedade", "estacionamento"],
          value: undefined,
        },
      ]);
    } else {
      setApCriadoPeloUsuario(false);
      setBloquearBotaoProximo(true);
      formApartamento.setFields([
        { name: ["propriedade", "nomeAp"] },
        { name: ["propriedade", "capacidade"] },
        { name: ["propriedade", "quartos"] },
        { name: ["propriedade", "banheiros"] },
        { name: ["propriedade", "metragem"] },
        { name: ["propriedade", "varanda"] },
        { name: ["propriedade", "terreo"] },
        { name: ["propriedade", "estacionamento"] },
      ]);
    }
  };

  //Função que Busca o empreendimento que o usuário cadastrou
  const buscarMeusEmpreendimentos = async () => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento`;

      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (response) {
          const empreendimentos: Empreendimentos[] = response.data;
          // Convertendo Token.id para inteiro antes de comparar
          const tokenId = Token.id;
          // Ordena os empreendimentos por ordem decrescente de created_at
          empreendimentos.sort((a, b) => {
            // Assume que created_at é uma string no formato adequado para comparação
            if (a.created_at < b.created_at) return 1;
            if (a.created_at > b.created_at) return -1;
            return 0;
          });

          // Filtra o empreendimento mais recente com base na origem do usuário
          const meuEmpreend = empreendimentos.find(
            (empreend) => empreend.origem === tokenId
          );

          if (meuEmpreend) {
            setMeusEmpreendimentos([meuEmpreend]); // Armazena o empreendimento mais recente no estado
          } else {
            setMeusEmpreendimentos([]); // Se não houver empreendimento, define como array vazio
          }
        }
      } catch (error) {
        console.error("Erro na solicitação:", error);
        if (error.response && error.response.status === 401) {
          logout();
          console.log("Erro de autenticação:", error);
        }
        console.error("Erro ao buscar meus empreendimentos:", error);
      }
    }
  };

  const buscarDadosProprietario = async (
    usuarioId: number
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response && response.data) {
          const values = {
            nome: response.data.nome,
            sobrenome: response.data.sobrenome,
            cpf: response.data.cpf,
            email: response.data.email,
            celular: response.data.celular,
            nacionalidade: response.data.nacionalidade,
            estadoCivil: response.data.estadoCivil,
          };
          setFormCadastroProprietario(values);
          proprietarioRef.current = response.data.id;
        }
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarEndereco = async (
    usuarioId: number,
    tipo: string
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response && response.data) {
          if (tipo === "proprietario") {
            setFormCadastroProprietario((prevState) => ({
              ...prevState,
              endereco: response.data.endereco,
              complemento: response.data.complemento,
              estadoId: response.data.estadoId,
              cidadeId: response.data.cidadeId,
            }));
            buscarMinhaCidade(response.data.cidadeId, "proprietario");
          } else if (tipo === "representante") {
            setFormAtualizarCadastro((prevState) => ({
              ...prevState,
              endereco: response.data.endereco,
              complemento: response.data.complemento,
              estadoId: response.data.estadoId,
              cidadeId: response.data.cidadeId,
            }));
            buscarMinhaCidade(response.data.cidadeId, "representante");
          } else {
            console.log(
              "Houve um erro ao buscar os dados, por favor tente novamente"
            );
          }
        }
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarDadosRepresentante = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const tokenId = Token.id;
      const URL = `${Globais.DOMINIOBACK}/usuario/${tokenId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response && response.data) {
          const values = {
            nacionalidade: response.data.nacionalidade,
            estadoCivil: response.data.estadoCivil,
            rg: response.data.rg,
          };
          setFormAtualizarCadastro(values);
          buscarEndereco(tokenId, "representante");
        }
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // Função que armazena o dado selecionado da varanda
  const possuiVarandaChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setPossuiVaranda(e.target.value);
  };

  // Função que armazena o dado selecionado do estacionamento
  const estacionamentoChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setEstacionamento(e.target.value);
  };

  // Função que armazena o dado selecionado do terreo
  const terreoChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setTerreo(e.target.value);
  };

  // Função que armazena no objetos os dados do formulario empreendimento
  const empreendimentosChange = (
    changedValues: Partial<Empreendimento>,
    allValues: Empreendimento
  ) => {
    changing.current = true;

    //validação do preenchimento dos campos

    if (
      formEmpreendimento.nome !== undefined ||
      formEmpreendimento.nome !== "" ||
      changedValues.nome !== ""
    ) {
      if (
        formEmpreendimento.pais !== undefined ||
        (changedValues.pais !== 0 && changedValues.pais !== undefined)
      ) {
        if (
          formEmpreendimento.estado !== undefined ||
          (changedValues.estado !== 0 && changedValues.estado !== undefined)
        ) {
          if (
            formEmpreendimento.cidadeId !== undefined ||
            (changedValues.cidadeId !== 0 &&
              changedValues.cidadeId !== undefined)
          ) {
            setBloquearBotaoProximo(false);
          }
        }
      }
    }

    //Caso o usuario apague o campo nome ele desabilitará o botão proximo
    if (changedValues.nome === "") {
      setBloquearBotaoProximo(true);
    }

    setFormEmpreendimento(allValues);
  };

  const verificarSeFormApartamentoProprietarioVazio = () => {
    if (
      formAp.nome === "" ||
      formAp.capacidade === null ||
      formAp.quartos === null ||
      formAp.banheiros === null ||
      formAp.varanda === null ||
      formAp.estacionamento === null ||
      formAp.terreo === null
    ) {
      setBloquearBotaoProximo(true);
    }
  };

  // Função que armazena os dados do formulario cadastro de apartamento
  const novoApartamentoChange = (
    changedValues: Partial<Apartamento>,
    allValues: Apartamento
  ) => {
    changing.current = true;
    setFormAp(allValues);

    if (
      changedValues.nome === "" ||
      changedValues.capacidade === null ||
      changedValues.quartos === null ||
      changedValues.banheiros === null
    ) {
      setBloquearBotaoProximo(true);
    }

    //validação preenchimento de todos os campos. Se as condições forem atendidas o botão proximo será liberado
    if (
      (formAp.nome === "" &&
        changedValues.nome !== "" &&
        !(
          (formAp.nome !== "" && changedValues.nome === "") ||
          changedValues.nome === undefined
        )) ||
      (formAp.nome !== "" && changedValues.nome !== "")
    ) {
      if (
        ((formAp.capacidade === undefined || formAp.capacidade === null) &&
          changedValues.capacidade !== null &&
          changedValues.capacidade !== null &&
          !(
            formAp.capacidade !== undefined && changedValues.capacidade === null
          )) ||
        (formAp.capacidade !== undefined && changedValues.capacidade !== null)
      ) {
        if (
          ((formAp.quartos === undefined || formAp.quartos === null) &&
            changedValues.quartos !== null &&
            changedValues.quartos !== undefined &&
            !(
              formAp.quartos !== undefined && changedValues.quartos === null
            )) ||
          (formAp.quartos !== undefined &&
            formAp.quartos !== undefined &&
            changedValues.quartos !== null)
        ) {
          if (
            ((formAp.banheiros === undefined || formAp.banheiros === null) &&
              changedValues.banheiros !== null &&
              changedValues.banheiros !== undefined &&
              !(
                formAp.banheiros !== undefined &&
                changedValues.banheiros === null
              )) ||
            (formAp.banheiros !== undefined && changedValues.banheiros !== null)
          ) {
            if (
              !(formAp.varanda === undefined || formAp.varanda === null) ||
              (changedValues.varanda !== null &&
                changedValues.varanda !== undefined)
            ) {
              if (
                !(
                  formAp.estacionamento === undefined ||
                  formAp.estacionamento === null
                ) ||
                (changedValues.estacionamento !== null &&
                  changedValues.estacionamento !== undefined)
              ) {
                if (
                  !(formAp.terreo === undefined || formAp.terreo === null) ||
                  (changedValues.terreo !== null &&
                    changedValues.terreo !== undefined)
                ) {
                  setBloquearBotaoProximo(false);
                }
              }
            }
          }
        }
      }
    }
  };

  // Função que armazena os dados do formulario de cadastro de mais informações do apartamento
  const MaisInfoApChange = (
    changedValues: Partial<MaisInfoAp>,
    allValues: MaisInfoAp
  ) => {
    changing.current = true;

    if (changedValues.numeroApto === "" || changedValues.andar === null) {
      setBloquearBotaoProximo(true);
    }

    if (
      (formInfo.numeroApto === "" &&
        changedValues.numeroApto !== "" &&
        !(
          (formInfo.numeroApto !== "" && changedValues.numeroApto === "") ||
          changedValues.numeroApto === undefined
        )) ||
      (formInfo.numeroApto !== "" && changedValues.numeroApto !== "")
    ) {
      if (
        (formInfo.andar === undefined && changedValues.andar !== undefined) ||
        (formInfo.andar !== undefined && changedValues.andar !== null)
      ) {
        if (
          (formInfo.vista === undefined &&
            changedValues.vista !== "" &&
            changedValues.vista !== undefined) ||
          (formInfo.vista !== undefined && changedValues.vista === undefined)
        ) {
          setBloquearBotaoProximo(false);
        }
      }
    }

  
    setFormInfo(allValues);
  };

  // Função que armazena os dados do apartamento selecionado
  const apEmpreendimentoChange = (changedValues: any, allValues: any) => {
    changing.current = true;
    setBloquearBotaoProximo(false);
    setApEmpreendimentoId(allValues.propriedade.nomeAp);
  };

  // Função de cadastrar o empreendimento
  const cadastrarOuAtualizarEmpreendimento = async (
    atualizar?: boolean
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento/${idEmpRef.current}`;

      if (atualizar) {
        const values = {
          ...formEmpreendimento,
        };

        try {
          const response = await axios.put(URL, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });

          console.log("response.data");
          console.log(response.data);
          if (response && response.data) {
            cronogramaEmp.current = response.data.cronograma;
            idEmpRef.current = response.data.id;
            setFormEmpreendimento(response.data);

            // Após cadastrar com sucesso, chama a função para buscar os empreendimentos atualizados

            buscarMeusEmpreendimentos();
          }

          return true;
        } catch (error) {
          console.error("Erro ao cadastrar o empreendimento", error);
          error("Erro ao cadastrar o empreendimento. Código erro: VCP-010");
          return false;
        }
      } else {
        const URLCriarEmpreendimento = `${Globais.DOMINIOBACK}/empreendimento/${formEmpreendimento.cidadeId}`;
        const values = {
          ...formEmpreendimento,
          origem: Token.id,
        };

        try {
          const response = await axios.post(URLCriarEmpreendimento, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response && response.data) {
            cronogramaEmp.current = response.data.cronograma;
            idEmpRef.current = response.data.id;

            const sucessoApto = cadastrarNovoApartamento();

            // Após cadastrar com sucesso, chama a função para buscar os empreendimentos atualizados

            buscarMeusEmpreendimentos();
          }

          return true;
        } catch (error) {
          console.error("Erro ao cadastrar o empreendimento", error);
          error("Erro ao cadastrar o empreendimento. Código erro. VCP-013");
          return false;
        }
      }
    } else {
      return false;
    }
  };


  // Função de cadastrar apartamento
  const cadastrarNovoApartamento = async (): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/apto`;
      const tokenId = Token.id;
      let values;

      if (origemMinhaCota === 0) {
        values = {
          ...formAp,
          origem: tokenId,
          empreendId: idEmpRef.current,
          nome: "",
          capacidade: undefined,
          quartos: undefined,
          banheiros: undefined,
          metragem: undefined,
          varanda: undefined,
          terreo: undefined,
          vista: undefined,
          estacionamento: undefined,
        };
      } else {
        values = {
          ...formAp,
          origem: tokenId,
          empreendId: idEmpRef.current,
        };
      }

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setOrigemAp(response.data.origem);
          origemApRef.current = response.data.origem;
          const aptoId = response.data.id;
          idApRef.current = response.data.id;
          setApEmpreendimentoId(response.data.id);

          setFormAp((prevState) => ({
            ...prevState, // mantém os valores antigos do estado
            id: response.data.id, // atualiza id com o valor da resposta
          }));

          criarOuAtualizarCota(aptoId);

          // alert("Apartamento Cadastrado com Sucesso!");
        } else {
          return false;
        }
        return true;
      } catch (error) {
        console.error("Erro ao cadastrar meu Apartamento", error);
        error("Há algo de errado. VCP-032");
        return false;
      }
    } else {
      return false;
    }
  };

  const editarAP = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/apto/${idApRef.current}`;
      const values = {
        ...formAp,
      };
      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        setApCriadoPeloUsuario(true);
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // Função de criar uma nova cota
  const criarOuAtualizarCota = async (
    aptoId?: number,
    atualizar?: boolean
  ): Promise<boolean> => {
    const Token = validateToken();
    const apId = aptoId ? aptoId : ApEmpreendimentoId;
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota/${apId}`;
      const tokenId = Token.id;
      const cota = 1;

      if (atualizar) {
        const valuesAtualizarCota = {
          aptoId: apId,
          numeroCota: null,
          qtdSemanas: 0,
        };

        try {
          const response = await axios.put(URL, valuesAtualizarCota, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response) {
            setCotaId(response.data.id);
            cotaIdRef.current = response.data.id;
          } else {
            error("Erro ao atualizar a cota");
          }

          return true;
        } catch (error) {
          console.error("Erro ao atualizar a cota", error);
          error("Erro ao atualizar a cota");
          return false;
        }
      } else {
        const valuesCriarCota = {
          aptoId: apId,
          origem: tokenId,
          numeroCota: cota,
          qtdSemanas: 0,
        };
        try {
          const response = await axios.post(URL, valuesCriarCota, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });

          if (response) {
            setCotaId(response.data.id);
            cotaIdRef.current = response.data.id;

            if (cotaUsuarioId !== 0) {
              const sucesso = atualizarCotaUsuario(
                "AGUARDANDO_APTO",
                0,
                "ALTERAR_COTAID",
                response.data.id
              );

              if (await sucesso) {
                return true;
              } else {
                error("Há algo errado. Código de erro: VCP-027");
              }
            } else {
              const sucesso = criarCotaUsuario(
                "AGUARDANDO_APTO",
                response.data.id
              );
              if (await sucesso) {
                return true;
              } else {
                error("Há algo errado. Código de erro: VCP-028");
              }
            }

            return true;
          } else {
            console.error("Erro ao cadastrar a cota", error);
            error("Erro ao cadastrar o cota. Código erro: VCP-006");
            return false;
          }
        } catch (error) {
          console.error("Erro ao cadastrar a cota", error);
          error("Erro ao cadastrar o cota. Código erro: VCP-005");
          return false;
        }
      }
    } else {
      return false;
    }
  };

  const obterCotaId = async () => {
    const Token = validateToken();
    const URLApto = `${Globais.DOMINIOBACK}/apto/${ApEmpreendimentoId}`;

    if (Token) {
      if (
        cotaUsuarioId === 0 &&
        (renderEmpSteps === 3 || renderEmpSteps === 2)
      ) {
        return cotaIdRef.current;
      } else {
        try {
          const responseApto = await axios.get(URLApto, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (responseApto) {
            const URLEmpreend = `${Globais.DOMINIOBACK}/empreendimento/${responseApto.data.empreendId}`;
            try {
              const responseEmpreend = await axios.get(URLEmpreend, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: Token.AuthStr,
                },
              });
              
              if (responseEmpreend) {
                if(origemApRef.current !== 0) {
                  cronogramaEmp.current = 2;
                }else{
                  cronogramaEmp.current = responseEmpreend.data.cronograma;
                }
                
                const URLCota = `${Globais.DOMINIOBACK}/cota/apto/${responseApto.data.id}`;

                try {
                  const responseCota = await axios.get(URLCota, {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: Token.AuthStr,
                    },
                  });
                  if (responseCota) {
                    let cotaId = 0;
                    responseCota.data.map((c: any, index: number) => {
                      if (index === 0) {
                        cotaId = c.id;
                      } else {
                        if (cotaId > c.id) {
                          cotaId = c.id;
                        }
                      }
                    });
                    return cotaId;
                  } else {
                    error(
                      "Há algo de errado. Favor entrar em contato conosco. VCP-007"
                    );
                  }
                } catch (e) {
                  console.log(e);
                  return 0;
                }
              }
            } catch (e) {
              console.log(e);
              return 0;
            }
          } else {
            error(
              "Há algo de errado. Favor entrar em contato conosco. VCP-015"
            );
          }
        } catch (e) {
          console.log(e);
          return 0;
        }
      }
    } else {
      document.location.href = "/login";
    }
  };
  const obterUsuarioIdCTU = async () => {
    const Token = validateToken();
    const URLCTU = `${Globais.DOMINIOBACK}/cota-usuario/${pCotaUsuarioId.pCotaUsuarioId}`;

    if (Token) {
      try {
        const responseCTU = await axios.get(URLCTU, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (responseCTU) {
          return responseCTU.data.usuarioId;
        } else {
          error("Há algo de errado. Favor entrar em contato conosco. VCP-041");
        }
      } catch (e) {
        console.log(e);
        return 0;
      }
    } else {
      document.location.href = "/login";
    }
  };

  // Função de criar uma cotaUsuario
  const criarCotaUsuario = async (
    status?: string,
    cotaNovaId?: number
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario`;

      const tokenId = Token.id;
      let minhaCotaId;

      if (cotaNovaId) {
        minhaCotaId = cotaNovaId;
      } else {
        minhaCotaId = await obterCotaId();
      }

      // Inicializa os valores do objeto com o conteúdo de formInfo
      const values = {
        ...formInfo,
        usuarioId: tokenId,
        status: status,
      };
      if (status !== undefined && status !== null && status !== "") {
        values.status = status;
      }
      // // Adiciona cotaId somente se não for nulo ou undefined
      if (
        minhaCotaId !== null &&
        minhaCotaId !== undefined &&
        minhaCotaId !== 0
      ) {
        values.cotaId = minhaCotaId;
      }

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response) {
          const formData = {
            status: "REGULAR",
          };
          const resultUsuario = await atualizarUsuarioGlobais(
            +Token.id,
            formData
          );
          if (resultUsuario) {
            document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=${response.data.id}`;
            setCotaUsuarioId(response.data.id);
          } else {
            error(
              "Há algo de errado. Entre em contato conosco. Código erro: VCP-096"
            );
          }
        } else {
          error(
            "Há algo de errado. Entre em contato conosco. Código erro: VCP-016"
          );
        }

        return true;
      } catch (error) {
        console.error("Erro ao cadastrar a cota usuario", error);
        error("Erro ao cadastrar o cota usuario. Código erro: VCP-017");
        return false;
      }
    } else {
      return false;
    }
  };

  // Função que armazena o id do pais selecionado para a atualização de cadastro e cadastro do proprietario
  const paisChange = (value: any) => {
    // Encontrar o país correspondente ao valor selecionado
    const paisSelecionado = paises.find((pais) => pais.abreviacao === value);

    // Verificar se encontrou o país
    if (paisSelecionado) {
      changing.current = true;
      setFormAtualizarCadastro((prevState) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
      setFormCadastroProprietario((prevState) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
    }
  };

  // Função que armazena os dados do formulario de atualização de cadastro
  const atualizarCadastroChange = (
    changedValues: Partial<Cadastro>,
    allValues: Cadastro
  ) => {
    changing.current = true;

    setFormAtualizarCadastro((prevState) => ({
      ...prevState,
      ...allValues,
    }));

    // caso os campos endereço e complemento sejam apagados o botão proximo fica desabilitado

    if (
      changedValues.endereco === "" ||
      changedValues.complemento === "" ||
      changedValues.rg === ""
    ) {
      setBloquearBotaoProximo(true);
    }

    // só habilita o botão proximo após validar
    if (allValues.rg !== "") {
      if (
        allValues.nacionalidade !== undefined &&
        allValues.nacionalidade !== ""
      ) {
        if (
          allValues.estadoCivil !== undefined &&
          allValues.estadoCivil !== ""
        ) {
          if (allValues.endereco !== undefined && allValues.endereco !== "") {
            if (
              allValues.complemento !== undefined &&
              allValues.complemento !== ""
            ) {
              if (allValues.estadoId !== undefined) {
                if (allValues.cidadeId !== undefined) {
                  console.log("desbloqueando");
                  setBloquearBotaoProximo(false);
                }
              }
            }
          }
        }
      }
    }
    // caso seja alterado o estado deverá ser selecionado a nova cidade.
    if (changedValues.estadoId !== undefined) {
      setBloquearBotaoProximo(true);
      warning("Selecione a cidade de sua residência.");
    }
  };

  // Função que armazena os dados do formulario de cadastro do proprietario
  const cadastrarProprietarioChange = (
    changedValues: Partial<Cadastro>,
    allValues: Cadastro
  ) => {
    changing.current = true;

    setFormCadastroNovoProprietario((prevState) => ({
      ...prevState,
      ...allValues,
    }));

    // let CPF = changedValues.cpf? validaCPF(changedValues.cpf):"";

    let cpfDigitado =
      changedValues.cpf !== undefined
        ? changedValues.cpf?.indexOf("_")
        : formCadastroNovoProprietario.cpf?.indexOf("_");
    let celularDigitado =
      changedValues.celular !== undefined
        ? changedValues.celular?.indexOf("_")
        : formCadastroNovoProprietario.celular?.indexOf("_");

    if (
      changedValues.nome === "" ||
      changedValues.sobrenome === "" ||
      cpfDigitado !== -1 ||
      changedValues.email === "" ||
      celularDigitado !== -1 ||
      changedValues.rg === "" ||
      changedValues.endereco === "" ||
      changedValues.complemento === ""
    ) {
      setBloquearBotaoProximo(true);
    }

    //validação preenchimento de todos os campos. Se as condições forem atendidas o botão proximo será liberado
    if (
      (formCadastroNovoProprietario.nome === "" &&
        changedValues.nome !== "" &&
        !(
          (formCadastroNovoProprietario.nome !== "" &&
            changedValues.nome === "") ||
          changedValues.nome === undefined
        )) ||
      (formCadastroNovoProprietario.nome !== "" && changedValues.nome !== "")
    ) {
      if (
        (!(
          formCadastroNovoProprietario.sobrenome === undefined &&
          changedValues.sobrenome === undefined
        ) &&
          !(
            formCadastroNovoProprietario.sobrenome !== undefined &&
            changedValues.sobrenome === ""
          )) ||
        (formCadastroNovoProprietario.sobrenome !== undefined &&
          changedValues.sobrenome !== undefined &&
          changedValues.sobrenome !== "")
      ) {
        if (cpfDigitado === -1) {
          if (allValues.email !== undefined && allValues.email !== "") {
            if (allValues.rg !== undefined && allValues.rg !== "") {
              if (celularDigitado === -1) {
                if (
                  allValues.nacionalidade !== undefined &&
                  allValues.nacionalidade !== ""
                ) {
                  if (
                    allValues.estadoCivil !== undefined &&
                    allValues.estadoCivil !== ""
                  ) {
                    if (
                      allValues.endereco !== undefined &&
                      allValues.endereco !== ""
                    ) {
                      if (
                        allValues.complemento !== undefined &&
                        allValues.complemento !== ""
                      ) {
                        if (allValues.estadoId !== undefined) {
                          if (allValues.cidadeId !== undefined) {
                            setBloquearBotaoProximo(false);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  // Função de atualização de cadastro
  const atualizarUsuario = async (statusUsuario: string): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const tokenId = Token.id;
      let usuarioId = 0;

      const values: Usuario = {};

      if (statusUsuario === "REPRESENTANTE") {
        usuarioId = tokenId;
        values.estadoCivil = formAtualizarCadastro.estadoCivil;
        values.nacionalidade = formAtualizarCadastro.nacionalidade;
        values.rg = formAtualizarCadastro.rg;
      }

      if (statusUsuario === "PROPRIETARIO") {
        usuarioId = proprietarioRef.current;
        values.nome = formCadastroNovoProprietario.nome;
        values.sobrenome = formCadastroNovoProprietario.sobrenome;

        // values.email = formCadastroNovoProprietario.email;
        // values.cpf = formCadastroNovoProprietario.cpf;
        values.celular = numberPadrao(formCadastroNovoProprietario.celular);
        values.estadoCivil = formCadastroNovoProprietario.estadoCivil;
        values.nacionalidade = formCadastroNovoProprietario.nacionalidade;
        values.rg = formCadastroNovoProprietario.rg;
      }

      const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          // document.location.reload();
        } else {
          error("Há algo de errado. Código de erro: VCP-044");
        }

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // Função de cadastro de endereço
  const cadastrarEndereco = async (usuarioId?: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const tokenId = usuarioId ? usuarioId : Token.id;
      const URL = `${Globais.DOMINIOBACK}/endereco`;
      const form = usuarioId
        ? formCadastroNovoProprietario
        : formAtualizarCadastro;
      const values = {
        usuarioId: tokenId,
        endereco: form.endereco,
        complemento: form.complemento,
        cidadeId: form.cidadeId,
        estadoId: form.estadoId,
        paisId: 2,
      };

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarMeuEndereco = async (statusUsuario: string): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      let usuarioId = 0;
      const tokenId = Token.id;
      if (statusUsuario === "REPRESENTANTE") {
        usuarioId = tokenId;
      }
      if (statusUsuario === "PROPRIETARIO") {
        usuarioId = proprietarioRef.current;
      }

      const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response.data && Object.keys(response.data).length > 0) {
          const sucesso = await atualizarEndereco(
            response.data.id,
            statusUsuario
          );
          if (sucesso) {
            return true;
          } else {
            return false;
          }
        } else {
          const sucesso = await cadastrarEndereco();
          if (sucesso) {
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const atualizarEndereco = async (
    enderecoId: number,
    statusUsuario: string
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/endereco`;
      const form =
        statusUsuario === "PROPRIETARIO"
          ? formCadastroProprietario
          : formAtualizarCadastro;
      const values = {
        endereco: form.endereco,
        complemento: form.complemento,
        cidadeId: form.cidadeId,
        estadoId: form.estadoId,
        paisId: form.paisId,
        enderecoId: enderecoId,
      };

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // Função principal que é chamada em handleNext para a atualização de DADOS

  const atualizarDados = async (status: string): Promise<boolean> => {
    const statusUsuario = status;
    const sucesso = await atualizarUsuario(statusUsuario);
    if (sucesso) {
      const sucesso = await buscarMeuEndereco(statusUsuario);
      if (sucesso) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarUsuario = async (usuarioLogadoId?: string) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/buscarUsuario`;
      const values = {
        usuarioLogadoId: usuarioLogadoId,
        email: formCadastroNovoProprietario.email,
        cpf: formCadastroNovoProprietario.cpf,
      };
      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response) {
          return response.data;
        } else {
          error("Há algo de errado. Código de erro: VCP-036");
          return false;
        }
      } catch (error) {
        throw error;
      }
    } else {
      return false;
    }
  };

  // Função de cadastro do proprietario
  const cadastrarUsuario = async (usuarioId?: number): Promise<boolean> => {
    const Token = validateToken();

    let usuarioIdProp;

    if (Token) {
      if (usuarioId) {
        usuarioIdProp = usuarioId;
      } else {
        const URL = `${Globais.DOMINIOBACK}/usuario/0/0`;
        const values = {
          nome: formCadastroNovoProprietario.nome,
          sobrenome: formCadastroNovoProprietario.sobrenome,
          email: formCadastroNovoProprietario.email,
          cpf: formCadastroNovoProprietario.cpf,
          rg: formCadastroNovoProprietario.rg,
          celular: numberPadrao(formCadastroNovoProprietario.celular),
          estadoCivil: formCadastroNovoProprietario.estadoCivil,
          nacionalidade: formCadastroNovoProprietario.nacionalidade,
        };

        try {
          const response = await axios.post(URL, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response) {
            usuarioIdProp = response.data.id;
            cadastrarEndereco(response.data.id);
          } else {
            error("Há algo de errado. VCP-092");
            return false;
          }

          return true;
        } catch (error) {
          return false;
        }
      }

      proprietarioRef.current = usuarioIdProp;
      const resultado = await atualizarCotaUsuario(
        "AGUARDANDO_COMPROVANTE",
        usuarioIdProp
      );
      if (resultado) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  // Função de atualização de cotaUsuario, do representante para o proprietario criado
  const atualizarCotaUsuario = async (
    status?: string,
    idProprietario?: number,
    tipo?: string,
    cotaNovaId?: number
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario/${pCotaUsuarioId.pCotaUsuarioId}`;
      const prioridade = formPrioridade ? formPrioridade.prioridade : null;
      const maisInfo: any = formMaisInfo;
      const keys: Array<keyof typeof maisInfo> = [
        "situacao",
        "valorVenda",
        "valorCondominio",
        "saldoDevedor",
      ];
      const values: any = {};

      // Adiciona usuarioId somente se idProprietario tiver um valor definido

      if (
        idProprietario !== undefined &&
        idProprietario !== null &&
        idProprietario !== 0
      ) {
        values.usuarioId = idProprietario;
      }
      if (
        prioridade !== undefined &&
        prioridade !== null &&
        prioridade !== ""
      ) {
        values.prioridade = prioridade;
      }
      if (tipo !== "ANUNCIO_POS_CADASTRO") {
        if (status !== undefined && status !== null && status !== "") {
          values.status = status;
        }
      }

      if (tipo === "ALTERAR_COTAID") {
        if (cotaNovaId) {
          values.cotaId = cotaNovaId;
        } else {
          values.cotaId = await obterCotaId();

          if (values.status === "AGUARDANDO_APTO") {
            values.status = "AGUARDANDO_APTOMAISINFO";
          }

          if (values.cotaId) {
            if (origemMinhaCota !== 0) {
              const URLCota = `${Globais.DOMINIOBACK}/cota/${cotaId}`;
              try {
                const responseCotaDelete = await axios.delete(URLCota, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: Token.AuthStr,
                  },
                });
                if (responseCotaDelete) {
                  if (origemApRef.current !== 0) {
                    const URLApto = `${Globais.DOMINIOBACK}/apto/${idApRef.current}`;
                    try {
                      const responseAptoDelete = await axios.delete(URLApto, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: Token.AuthStr,
                        },
                      });
                      if (responseAptoDelete) {
                        if (naoEncontrouEmpreendimento) {
                          const URLEmp = `${Globais.DOMINIOBACK}/empreendimento/${idEmpRef.current}`;
                          try {
                            const responseEmpDelete = await axios.delete(
                              URLEmp,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: Token.AuthStr,
                                },
                              }
                            );
                            if (responseEmpDelete) {
                              console.log("deletado");
                            } else {
                              error("Há algo de errado. Código erro: VCP-026.");
                            }
                          } catch (e) {
                            console.log(e);
                            error("Há algo de errado. Código erro: VCP-025.");
                          }
                        }
                      } else {
                        error("Há algo de errado. Código erro: VCP-023.");
                      }
                    } catch (e) {
                      console.log(e);
                      error("Há algo de errado. Código erro: VCP-022.");
                    }
                  }
                } else {
                  error("Há algo de errado. Código erro: VCP-021.");
                }
              } catch (e) {
                console.log(e);
                error("Há algo de errado. Código erro: VCP-020.");
              }
            }
          }
        }
      }

      if (tipo === "MODIFICAR_CTU_NAOENCONTRADO") {
        const responseDelete = await axios.delete(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (responseDelete) {
          return true;
        } else {
          error("Não foi possível atualizar a propriedade. VCP-012");
        }
      }

      if (status === "AGUARDANDO_TITULARIDADE") {
        values.andar = formInfo.andar;
        values.bloco = formInfo.bloco;
        values.numeroApto = formInfo.numeroApto;
        values.vista = formInfo.vista;
        values.cotaId = await obterCotaId();
      }
      if (tipo === "ALTERAR_MAIS_INFO") {
        values.andar = formInfo.andar;
        values.bloco = formInfo.bloco;
        values.numeroApto = formInfo.numeroApto;

        values.vista = formInfo.vista;
      }

      // Atualiza os valores somente se os valores em maisInfo não forem undefined ou null
      keys.forEach((key) => {
        if (maisInfo[key] !== undefined && maisInfo[key] !== null) {
          values[key] = maisInfo[key];
        }
      });

      if (
        (status === "AGUARDANDO_PERIODOS" ||
          status === "AGUARDANDO_DEFINICAO_ANUNCIO") &&
        formMinhaCota.id !== undefined &&
        formMinhaCota.id !== null
      ) {
        values.cotaId = formMinhaCota.id;
      }

      if (tipo === "ALTERAR_COTAID" && !values.cotaId) {
        try {
          const responseDelete = await axios.delete(URL, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (responseDelete) {
            const sucessoCotaUsuario = await criarCotaUsuario(
              "AGUARDANDO_APTOMAISINFO"
            );

            if (sucessoCotaUsuario) {
              return true;
            }
          } else {
            error("Há algo de errado.  Código erro: VCP-018");
          }
        } catch (error) {}
        return false;
      } else {
        try {
          const response = await axios.put(URL, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response) {
            setCotaUsuarioId(response.data.id);
          }

          return true;
        } catch (error) {
          console.log(error);
          return false;
        }
      }
    } else {
      return false;
    }
  };

  // Função de cadastro do representante

  const cadastrarRepresentante = async () => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/representante`;
      const values = {
        usuarioId: Token.id,
        cotaUsuarioId: cotaUsuarioId,
      };
      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-038");
      }
    }
  };
  // Função de deletar cadastro do representante

  const deletarRepresentante = async () => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;

      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          const representante = response.data.filter((p: any) => {
            if (p.cotasUsuariosId === pCotaUsuarioId.pCotaUsuarioId) {
              return p;
            }
          });
          if (representante) {
            const URLDelete = `${Globais.DOMINIOBACK}/representante/${representante[0].id}`;
            const responseDelete = await axios.delete(URLDelete, {
              headers: {
                "Content-Type": "application/json",
                Authorization: Token.AuthStr,
              },
            });
            if (responseDelete) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-048");
      }
    }
  };
  // Função principal que é chamada em handleNext para cadastro do proprietario
  const cadastrarProprietario = async (
    usuarioId?: number
  ): Promise<boolean> => {
    // Verifica se o proprietario cadastrado ja existe

    let sucessoUsuario;

    if (usuarioId) {
      sucessoUsuario = await cadastrarUsuario(usuarioId);
    } else {
      sucessoUsuario = await cadastrarUsuario();
    }

    if (sucessoUsuario) {
      const sucessoRepresentante = cadastrarRepresentante();
      if (await sucessoRepresentante) {
        return true;
      } else {
        return false;
      }
    } else {
      error("Há algo de errado. Código erro: VCP-037");
      return false;
    }
  };

  // Função de Armazenamento se o usuario vai ou nao anunciar
  const anunciarChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setBloquearBotaoProximo(false);
    setAnunciar(e.target.value);
    if (e.target.value === 1) {
    } else {
    }
  };

  const buscarCotas = async (): Promise<boolean> => {
    const Token = validateToken();
    if (!Token) {
      return false; // Retorna false se o token não for válido
    }

    const URL = `${Globais.DOMINIOBACK}/cota`;

    try {
      const response = await axios.get(URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: Token.AuthStr,
        },
      });

      if (response && response.data) {
        const cotas: Cotas[] = response.data;
        let cotasDoUsuario: Cotas[] = [];

        switch (cronogramaEmp.current === 1 || cronogramaRef.current === 1) {
          case origemAp === 0 || origemApRef.current === 0:
            //Filtrando as cotas de acordo com o apartamento registrado
            cotasDoUsuario = cotas.filter(
              (cotas: Cotas) =>
                cotas.aptoId === (formAp.id || idApRef.current) &&
                cotas.origem === 0
            );
            break;
          case origemAp !== 0 || origemApRef.current !== 0:
            //Filtrando as cotas de acordo com o apartamento registrado
            cotasDoUsuario = cotas.filter(
              (cotas: Cotas) => cotas.aptoId === (formAp.id || idApRef.current)
            );
            break;
          default:
            console.error(
              "Não foi possivel resgatar as cotas, por favor entre em contato"
            );
            break;
        }

        setCotasUsuario(cotasDoUsuario);

        return true;

        // Retorna true se tudo correr bem e o array não estiver vazio
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false; // Retorna false se houver um erro na chamada da API
    }
  };

  const prioridadeChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;

    setFormPrioridade((prevState: any) => ({
      ...prevState,
      prioridade: allValues.prioridade,
    }));

    if (formPrioridade !== null || changedValues.prioridade !== "") {
      setBloquearBotaoProximo(false);
    }
    if (changedValues.prioridade === "") {
      setBloquearBotaoProximo(true);
    }
  };

  const atualizarMinhaCota = async (tipo?: string): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota/${idMinhaCota}`;
      let values;
      switch (tipo) {
        case "atualizarNumeroCota":
          if (origemApRef.current === 0) {
            values = {
              numeroCota: formMinhaCota.numeroCota,
            };
          } else {
            values = {
              numeroCota: formMinhaCotaOrigemProprietario.numeroCota,
            };
          }

          break;
        case "atualizarQtdSemanas":
          values = {
            qtdSemanas: formSemanasPorAno.semanasPorAno,
          };
          break;
        case "atualizarDiaSemana":
          values = {
            diaDaSemanaInicio: formDiaDaSemana.diaDaSemana,
          };
          break;
      }

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          return true;
        } else {
          error("Há algo de errado. Código de erro: VCP-071");
          return false;
        }

        return true;
      } catch (error) {
        console.log(error);
        error("Há algo de errado. Código de erro: VCP-072");
        return false;
      }
    } else {
      return false;
    }
  };

  const semanasPorAnoChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    formSemanasPorAno.semanasPorAno = changedValues.semanasPorAno;

    if (changedValues.semanasPorAno === "") {
      setBloquearBotaoProximo(true);
    } else {
      if (
        changedValues.semanasPorAno === "1" ||
        changedValues.semanasPorAno === "2" ||
        changedValues.semanasPorAno === "3" ||
        changedValues.semanasPorAno === "4"
      ) {
        setBloquearBotaoProximo(false);
      } else {
        error("O sistema só permite incluir de 1 a 4 semanas.");
        setBloquearBotaoProximo(true);
      }
    }
  };

  const diaDaSemanaChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    //setFormDiaDaSemana(allValues.diaDaSemana);
    formDiaDaSemana.diaDaSemana = changedValues.diaDaSemana;

    if (changedValues.diaDaSemana !== "") {
      setBloquearBotaoProximo(false);
    }
  };
  const [minhaSituacao, setMinhaSituacao] = useState<string>();

  const [maisInfoForm] = Form.useForm(); // Cria uma referência ao formulário

  const maisInfoChange = (changedValues: Partial<any>, allValues: any) => {
    setFormMaisInfo(allValues);
    changing.current = true;
    setMinhaSituacao(allValues.situacao);

    const { situacao, valorVenda, valorCondominio, saldoDevedor } = allValues;

    // Reseta saldoDevedor se situacao nao for "NAO_QUITADO"
    if (situacao !== "NAO_QUITADO") {
      maisInfoForm.resetFields(["saldoDevedor"]);
    }



    if (
      changedValues.valorVenda == 0 ||
      changedValues.valorCondominio == 0 ||
      ((changedValues.situacao === "NAO_QUITADO" ||
        situacao === "NAO_QUITADO") &&
        (saldoDevedor === null ||
          saldoDevedor === undefined ||
          saldoDevedor === 0 ||
          changedValues.saldoDevedor === 0))
    ) {
      setBloquearBotaoProximo(true);
    } else {
      if (
        (situacao !== null || changedValues.situacao !== undefined) &&
        (valorVenda !== null || changedValues.valorVenda !== undefined) &&
        (valorCondominio !== null ||
          changedValues.valorCondominio !== undefined)
      ) {
        setBloquearBotaoProximo(false);
      }
    }
  };

  const numeroCotaChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    const selectedOption = changedValues.numeroCota;
    if (selectedOption) {
      const { value, label } = selectedOption;
      changing.current = true;

      // formMinhaCota.current = {id: value, numeroCota: label};
      setFormMinhaCota({
        id: value,
        numeroCota: label,
      });
      setFormMinhaCotaOrigemProprietario({ numeroCota: value });
      if (
        !formMinhaCota.numeroCota === null ||
        changedValues.numeroCota.value !== null
      ) {
        setBloquearBotaoProximo(false);
      }
    } else {
      console.error("Erro ao selecionar cotas");
    }
  };
  const numeroCotaOrigemProprietarioChange = (
    changedValues: Partial<any>,
    allValues: any
  ) => {
    changing.current = true;

    //  setFormNumeroCota(changedValues.numeroCota);
    changing.current = true;

    setFormMinhaCota((prevState) => ({
      ...prevState,
      numeroCota: changedValues.numeroCota,
    }));
    setFormMinhaCotaOrigemProprietario((prevState) => ({
      ...prevState,
      numeroCota: changedValues.numeroCota,
    }));

    if (!isNaN(changedValues.numeroCota)) {
      if (
        !formMinhaCota.numeroCota === undefined ||
        changedValues.numeroCota !== ""
      ) {
        setBloquearBotaoProximo(false);
      }
    }

    if (changedValues.numeroCota === "") {
      setBloquearBotaoProximo(true);
    }

    if (isNaN(changedValues.numeroCota)) {
      error("Favor inserir um número");
    }
  };
  // Função que realiza o Upload de arquivos

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };
  const handleUpload = async () => {
    changing.current = true;
    const formData = new FormData();
    const Token = validateToken();

    if (Token) {
      const URLArquivo = `${Globais.DOMINIOBACK}/arquivo/upload`;
      let cotaUsuarioIdArquivo =
        pCotaUsuarioId.pCotaUsuarioId?.toLocaleString();

      if (cotaUsuarioIdArquivo) {
        fileList.forEach((file) => {
          formData.append("files[]", file as FileType);
        });
      }
      setUploading(true);

      try {
        const uploadPromises = fileList.map(async (f: any) => {
          let formData = {
            file: f,
            tipo: "1",
            cotaUsuarioId: cotaUsuarioIdArquivo,
            origem: Token?.id,
          };

          return axios.post(URLArquivo, formData, {
            headers: {
              Authorization: Token.AuthStr,
              "Content-type": "multipart/form-data",
            },
          });
        });

        // Aguarda todas as requisições serem concluídas
        const responses = await Promise.all(uploadPromises);

        // Se retornadas, chama chama a funçao handleNext
        if (responses) {
          message.success("Arquivo(s) anexado(s) com sucesso!");
          setUploading(false);
          handleNext();
        }
      } catch (error) {
        message.error("Há algo de errado. Código erro: VCP-097");
        if (error.response?.data?.status === 502) {
          error(
            "Ops. Algo deu errado. Entre em contato conosco. Código erro: VCP-019"
          );
        }
      }
    }
  };

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const buscarMeuArquivo = async () => {
    const formData = new FormData();
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/arquivo-cota-usuario/cotaUsuario/${cotaUsuarioRef.current}`;

      try {
        const response = await axios.get(URL, {
          headers: {
            Authorization: Token.AuthStr,
            "Content-type": "multipart/form-data",
          },
        });

        setUploadedFiles(response.data);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const excluirCota = async () => {
    const Token = validateToken();
    const URL = `${Globais.DOMINIOBACK}/cota/${cotaId}`;

    if (Token) {
      try {
        const response = await axios.delete(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const verificarAnuncioPropriedade = async () => {
    const Token = validateToken();
    const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/venda/cotaUsuario/${pCotaUsuarioId.pCotaUsuarioId}`;

    if (Token) {
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (Array.isArray(response.data) && response.data.length > 0) {
          const { active, dataInativacaoAnuncio } = response.data[0]; // Acesse o primeiro item do array
          // Converte dataInativacaoAnuncio para um objeto Date
          const inactivationDate = new Date(dataInativacaoAnuncio);

          if (
            active === 1 &&
            (inactivationDate > new Date() || isNaN(inactivationDate.getTime()))
          ) {
            return true;
          }
        }

        return false; // Retorna false se não passar nas verificações
      } catch (error) {
        console.error(error);
      }
    }
  };

  const [anuncioPropriedade, setAnuncioPropriedade] = useState<boolean>();
  //----------------  Componentes --------------------

  // Componente De qual empreendimento é sua propriedade?
  const selecionarEmpreendimento = (
    <>
      <Card
        title={
          <CardTitle> De qual empreendimento é sua propriedade?</CardTitle>
        }
        bordered={true}
        type="inner"
        className="mobile"
        style={{
          width: "100%",
        }}
      >
        <div className="containerEmpreendimento">
          <Select
            showSearch
            className="selectEmpreendimento"
            placeholder="Selecione um empreendimento"
            optionFilterProp="children"
            onChange={handleSelectChange}
            filterOption={(input, option) => {
              if (typeof option?.label === "string") {
                const inputLowerCase = input.toLowerCase();
                const labelLowerCase = option.label.toLowerCase();
                return (
                  labelLowerCase.includes(inputLowerCase) ||
                  option.label.includes(input) || // original input
                  option.label
                    .toLowerCase()
                    .includes(
                      inputLowerCase.charAt(0).toUpperCase() +
                        inputLowerCase.slice(1)
                    )
                );
              }
              return false;
            }}
            filterSort={(optionA, optionB) => {
              if (
                typeof optionA?.label === "string" &&
                typeof optionB?.label === "string"
              ) {
                return optionA.label
                  .toLowerCase()
                  .localeCompare(optionB.label.toLowerCase());
              }
              return 0;
            }}
            disabled={empreendimentoNaoSelecionado || bloqueadoEdicao.current}
            value={
              empreedimentoSelecionado ? empreedimentoSelecionado.id : undefined
            }
          >
            {empreendimento.map((emp: Empreendimento) => (
              <Select.Option key={emp.id} value={emp.id} label={emp.nome}>
                {emp.nome}
              </Select.Option>
            ))}
          </Select>
          <Checkbox
            disabled={bloqueadoEdicao.current}
            onChange={naoEncontradoChange}
            className="checkBoxEmpreendimento"
            checked={naoEncontrouEmpreendimento}
          >
            Não encontrou ?
          </Checkbox>
        </div>
      </Card>
    </>
  );

  const cadastrarEmpreendimentoMensagem = (
    <>
      {!empreedimentoSelecionado && (
        <>
          <Card
            title={<CardTitle> Multicotas</CardTitle>}
            bordered={true}
            type="inner"
            className="mobile"
          >
            <div>
              <h3>Cadastre o empreendimento e mais informações a seguir:</h3>
            </div>
          </Card>
        </>
      )}
    </>
  );

  const cadastrarEmpreendimentos = (
    <>
      <Card
        title={<CardTitle>Conte-me mais sobre o empreendimento:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          form={formAtualizarEstadoEmpreendimento}
          {...layout}
          name="cadastrar-empreendimento"
          //onFinish={cadastrarEmpreendimento}
          initialValues={formEmpreendimento}
          onValuesChange={(changedValues, allValues) =>
            empreendimentosChange(changedValues, allValues)
          }
          style={{
            marginLeft: "-10%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["nome"]}
            label="Nome empreendimento"
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["pais"]}
            label="Pais"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select>
              {paises.map((pais) => (
                <Select.Option key={pais.id} value={pais.id}>
                  {pais.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["estado"]}
            label="Estado"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o estado"
              onChange={(value) =>
                handleEstadoChange(value, formAtualizarEstadoEmpreendimento)
              }
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {estados.map((estado) => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nome}
                >
                  {estado.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["cidadeId"]}
            label="Cidade"
            id={"formCidades"}
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione a cidade"
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {cidades.map((cidade) => (
                <Select.Option
                  key={cidade.id}
                  value={cidade.id}
                  label={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );

  // Componente Selecione seu apartamento
  const especificacoesApto = (
    <>
      <Card
        title={<CardTitle> Selecione seu apartamento</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
        style={{
          width: "100%",
        }}
      >
        <Form
          form={formApartamento}
          {...layout}
          disabled={bloqueadoEdicao.current}
          name="cadastrar-propriedade"
          onValuesChange={apEmpreendimentoChange}
          initialValues={{
            propriedade: {
              nome: apSelecionado ? apSelecionado.nome : "",
              capacidade: apSelecionado ? apSelecionado.capacidade : "",
              quartos: apSelecionado ? apSelecionado.quartos : "",
              banheiros: apSelecionado ? apSelecionado.banheiros : "",
              metragem: apSelecionado ? apSelecionado.metragem : "",
              varanda: apSelecionado ? apSelecionado.varanda : "",
              // terreo: apSelecionado ? apSelecionado.terreo : "",
              estacionamento: apSelecionado ? apSelecionado.estacionamento : "",
            },
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["propriedade", "nomeAp"]}
            label="Nome apartamento"
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o apartamento"
              onChange={handleEmpreendimentoApChange}
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  return option.label.includes(input);
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
              disabled={apCriadoPeloUsuario || bloqueadoEdicao.current}
            >
              {empreendimentoAp.map((emp: ApData) => (
                <Select.Option key={emp.id} value={emp.id} label={emp.nome}>
                  {emp.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["propriedade", "capacidade"]}
            label="Capacidade"
            className="formItems"
          >
            <Input style={{ width: "30%" }} readOnly />
          </Form.Item>
          <Form.Item
            name={["propriedade", "quartos"]}
            label="Quartos"
            className="formItems"
          >
            <Input style={{ width: "30%" }} readOnly />
          </Form.Item>
          <Form.Item
            name={["propriedade", "banheiros"]}
            label="Banheiros"
            className="formItems"
          >
            <Input style={{ width: "30%" }} readOnly />
          </Form.Item>
        </Form>

        <div className="formItems">
          <Checkbox
            disabled={bloqueadoEdicao.current}
            onChange={naoEncontradoAp}
            style={{
              marginLeft: 10,
              marginTop: 20,
            }}
            checked={apCriadoPeloUsuario}
          >
            Não encontrou o apartamento?
          </Checkbox>
        </div>
      </Card>
    </>
  );

  // Componente Conte-me mais sobre o apartamento
  const cadastrarApartamento = (
    <>
      <>
        <Card
          title={<CardTitle>Conte-me mais sobre o apartamento</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
          style={{ width: "100%" }}
        >
          <Form
            {...layout}
            name="cadastrar-apartamento"
            onValuesChange={(changedValues, allValues) =>
              novoApartamentoChange(changedValues, allValues)
            }
            initialValues={formAp}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={"empreendId"}
              label="Empreendimento: "
              className="formItems"
              rules={[{ required: true }]}
            >
              {empreedimentoSelecionado ? (
                <Select>
                  <Select.Option
                    key={empreedimentoSelecionado.id}
                    value={empreedimentoSelecionado.id}
                  >
                    {empreedimentoSelecionado.nome}
                  </Select.Option>
                </Select>
              ) : (
                <Select>
                  {meusEmpreendimentos.map((mp, index) => (
                    <Select.Option key={mp.id} value={mp.id}>
                      {mp.nome}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item
              name={["nome"]}
              label="Nome apartamento: "
              className="formItems"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["capacidade"]}
              label="Capacidade: "
              className="formItems"
            >
              <InputNumber min={0} />
            </Form.Item>
            <Form.Item
              name={["quartos"]}
              label="Quartos: "
              className="formItems"
            >
              <InputNumber min={0} />
            </Form.Item>
            <Form.Item
              name={["banheiros"]}
              label="Banheiros: "
              className="formItems"
            >
              <InputNumber min={0} />
            </Form.Item>
            <Form.Item
              name={["varanda"]}
              label="Possui Varanda: "
              rules={[{ required: true }]}
              className="formItems"
            >
              <Radio.Group onChange={possuiVarandaChange} value={possuiVaranda}>
                <Radio value={0}>Não</Radio>
                <Radio value={1}>Sim</Radio>
                <Radio value={2}>Não Sei</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name={["estacionamento"]}
              label="Estacionamento: "
              rules={[{ required: true }]}
              className="formItems"
            >
              <Radio.Group
                onChange={estacionamentoChange}
                value={estacionamento}
              >
                <Radio value={0}>Não</Radio>
                <Radio value={1}>Sim</Radio>
                <Radio value={2}>Não Sei</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name={["terreo"]}
              label="Térreo: "
              rules={[{ required: true }]}
              className="formItems"
            >
              <Radio.Group onChange={terreoChange} value={terreo}>
                <Radio value={0}>Não</Radio>
                <Radio value={1}>Sim</Radio>
                <Radio value={2}>Não Sei</Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  // Componente Mais informações do apartamento
  const maisInfoApartamento = (
    <>
      <Card
        title={<CardTitle> Mais informações do apartamento</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          {...layoutAp}
          name="cadastrar-apartamento"
          onValuesChange={(changedValues, allValues) =>
            MaisInfoApChange(changedValues, allValues)
          }
          initialValues={formInfo}
          style={{
            marginLeft: "-15%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["numeroApto"]}
            label="Nº do apartamento:"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["andar"]}
            label="Andar: "
            rules={[{ required: true }]}
            className="formItems"
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name={["bloco"]} label="Bloco: " className="formItems">
            <Input />
          </Form.Item>
          <Form.Item
            name={["vista"]}
            label="Vista: "
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              style={{ width: 150 }}
              options={vistaOptions}
              // defaultValue={1}
            />
          </Form.Item>
        </Form>
      </Card>
    </>
  );
  const titularidadePropriedade = (
    <>
      <Card
        title={<CardTitle>Sobre a titularidade da propriedade:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
        style={{ width: "100%" }}
      >
        <Radio.Group
          disabled={bloqueadoEdicao.current}
          onChange={propriedadeChange}
          value={propriedadeRes}
          className="custom-radio"
        >
          <Space direction="vertical">
            {state === "AGUARDANDO_TITULARIDADE" ? (
              <Radio value={0} disabled>
                Selecione uma opção
              </Radio>
            ) : null}
            <Radio value={1}>A propriedade está em meu nome</Radio>
            <Radio value={2}>A propriedade está em nome de outra pessoa</Radio>
          </Space>
        </Radio.Group>
        <div>
          <h6 style={{ fontSize: 15, marginTop: "20px", color: "red" }}>
            O nome do proprietário titular deve constar nos documentos
            referentes à propriedade, como boletos de condomínio, entre outros.
          </h6>
        </div>
      </Card>
    </>
  );
  const cronogramaFixoOuPrioridadeComponente = (
    <>
      <>
        <Card
          title={<CardTitle>Como são definidos seus períodos?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Radio.Group
            disabled={bloqueadoEdicao.current}
            onChange={cronogramaFixoOuPrioridadeChange}
            value={cronogramaFixoOuPrioridade}
            className="custom-radio"
          >
            <Space direction="vertical">
              {cronogramaFixoOuPrioridade === 0 ? (
                <Radio value={0} disabled>
                  Selecione uma opção
                </Radio>
              ) : null}
              <Radio value={1}>
                Períodos definidos em um cronograma ou calendário fixo.
              </Radio>
              <Radio value={2}>
                Períodos definidos periodicamente de acordo com uma prioridade.
              </Radio>
            </Space>
          </Radio.Group>
        </Card>
      </>
    </>
  );

  const titularidadeOutraPessoaMensagem = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Certo. <br />
            Faremos uma procuração simples a qual o proprietário lhe dará
            poderes para representá-lo perante a Multicotas. <br />
            Como disse antes, é simples e poderá ser assinado pelo celular.
            <br />
            Após finalização do cadastro, nossa equipe entrará em contato para
            darmos prosseguimento.
          </h3>
        </div>
      </Card>
    </>
  );

  const atualizarCadastroOutraPessoa = (
    <>
      <Card
        title={<CardTitle> Favor atualizar seu cadastro:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          form={formAtualizarEstadoCadastro}
          {...layout}
          name="atualizar-cadastro"
          onValuesChange={(changedValues, allValues) =>
            atualizarCadastroChange(changedValues, allValues)
          }
          initialValues={formAtualizarCadastro}
          style={{
            padding: -30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["nacionalidade"]}
            label="Nacionalidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              onChange={paisChange}
              placeholder="Selecione a nacionalidade"
            >
              {paises.map((pais) => (
                <Select.Option key={pais.id} value={pais.abreviacao}>
                  {pais.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["rg"]}
            label="RG"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input disabled={cpfEmailBloqueado} placeholder="Digite seu RG" />
          </Form.Item>

          <Form.Item
            name={["estadoCivil"]}
            label="Estado civil"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select>
              {estadoCivil.map((ec, index) => (
                <Select.Option key={ec.id} value={ec.value}>
                  {ec.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["endereco"]}
            label="Endereço"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["complemento"]}
            label="Complemento"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["estadoId"]}
            label="Estado"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o estado"
              onChange={(value) =>
                handleEstadoChange(value, formAtualizarEstadoCadastro)
              }
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {estados.map((estado) => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nome}
                >
                  {estado.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["cidadeId"]}
            label="Cidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione a cidade"
              optionFilterProp="children"
            >
              {cidades.map((cidade) => (
                <Select.Option
                  key={cidade.id}
                  value={cidade.id}
                  label={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );

  const atualizarCadastroProprietario = (
    <>
      <>
        <Card
          title={<CardTitle> Favor informar dados do proprietário:</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            form={formAtualizarEstadoDadosProprietario}
            {...layout}
            name="dados-proprietario"
            onValuesChange={(changedValues, allValues) =>
              cadastrarProprietarioChange(changedValues, allValues)
            }
            initialValues={formCadastroProprietario}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["nome"]}
              label="Nome"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["sobrenome"]}
              label="Sobrenome"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["cpf"]}
              label="CPF"
              rules={[{ required: true }]}
              className="formItems"
            >
              <MaskedInput disabled={cpfEmailBloqueado} mask="000.000.000-00" />
            </Form.Item>
            <Form.Item
              name={["rg"]}
              label="RG"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} placeholder="Digite seu RG" />
            </Form.Item>
            <Form.Item
              name={["email"]}
              label="E-mail"
              rules={[{ required: true, type: "email" }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["celular"]}
              label="Celular"
              rules={[
                {
                  required: true,
                  message: "Por favor, insira seu celular!",
                },
              ]}
              className="formItems"
            >
              <PhoneInput
                country={"br"}
                value={phone}
                onChange={handlePhoneChange}
                placeholder="Digite seu telefone"
                disabled={cpfEmailBloqueado}
                inputClass="phone-input"
              />
            </Form.Item>
            <Form.Item
              name={["nacionalidade"]}
              label="Nacionalidade"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select
                onChange={paisChange}
                placeholder="Selecione a nacionalidade"
                disabled={cpfEmailBloqueado}
              >
                {paises.map((pais) => (
                  <Select.Option key={pais.id} value={pais.abreviacao}>
                    {pais.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={["estadoCivil"]}
              label="Estado Civil"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select disabled={cpfEmailBloqueado}>
                {estadoCivil.map((ec, index) => (
                  <Select.Option key={ec.id} value={ec.value}>
                    {ec.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={["endereco"]}
              label="Endereço"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["complemento"]}
              label="Complemento"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>

            <Form.Item
              name={["estadoId"]}
              label="Estado"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select
                disabled={cpfEmailBloqueado}
                showSearch
                placeholder="Selecione o estado"
                onChange={(value) =>
                  handleEstadoChange(
                    value,
                    formAtualizarEstadoDadosProprietario
                  )
                }
                filterOption={(input, option) => {
                  if (typeof option?.label === "string") {
                    const inputLowerCase = input.toLowerCase();
                    const labelLowerCase = option.label.toLowerCase();
                    return (
                      labelLowerCase.includes(inputLowerCase) ||
                      option.label.includes(input) || // original input
                      option.label
                        .toLowerCase()
                        .includes(
                          inputLowerCase.charAt(0).toUpperCase() +
                            inputLowerCase.slice(1)
                        )
                    );
                  }
                  return false;
                }}
                filterSort={(optionA, optionB) => {
                  if (
                    typeof optionA?.label === "string" &&
                    typeof optionB?.label === "string"
                  ) {
                    return optionA.label
                      .toLowerCase()
                      .localeCompare(optionB.label.toLowerCase());
                  }
                  return 0;
                }}
              >
                {estados.map((estado) => (
                  <Select.Option
                    key={estado.id}
                    value={estado.id}
                    label={estado.nome}
                  >
                    {estado.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={["cidadeId"]}
              label="Cidade"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select
                disabled={cpfEmailBloqueado}
                showSearch
                placeholder="Selecione a cidade"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  if (typeof option?.label === "string") {
                    const inputLowerCase = input.toLowerCase();
                    const labelLowerCase = option.label.toLowerCase();
                    return (
                      labelLowerCase.includes(inputLowerCase) ||
                      option.label.includes(input) || // original input
                      option.label
                        .toLowerCase()
                        .includes(
                          inputLowerCase.charAt(0).toUpperCase() +
                            inputLowerCase.slice(1)
                        )
                    );
                  }
                  return false;
                }}
                filterSort={(optionA, optionB) => {
                  if (
                    typeof optionA?.label === "string" &&
                    typeof optionB?.label === "string"
                  ) {
                    return optionA.label
                      .toLowerCase()
                      .localeCompare(optionB.label.toLowerCase());
                  }
                  return 0;
                }}
              >
                {cidades.map((c) => (
                  <Select.Option key={c.id} value={c.id} label={c.nome}>
                    {c.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const comprovantePropriedade = (
    <>
      <>
        <Card
          title={<CardTitle>Incluir comprovante da propriedade</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Upload {...props}>
            <ButtonForm icon={<UploadOutlined />}>
              Clique para carregar arquivo
            </ButtonForm>
          </Upload>
          <Flex align="center" justify="center">
            <ButtonForm
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0}
              loading={uploading}
              style={{ marginTop: 50 }}
            >
              {uploading ? "Uploading" : "Anexar"}
            </ButtonForm>
          </Flex>

          {uploadedFiles.length > 0 && (
            <List
              style={{ marginTop: 20 }}
              header={<div>Arquivos Carregados</div>}
              bordered
              dataSource={uploadedFiles}
              renderItem={(item: any) => (
                <List.Item>
                  <a
                    href={item.ArquivoTable.path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.ArquivoTable.originalname}
                  </a>
                </List.Item>
              )}
            />
          )}

          <div>
            <h6 style={{ fontSize: 15, marginTop: "20px", color: "red" }}>
              O nome do proprietário titular deve constar nos documentos
              referentes à propriedade, como boletos de condomínio, entre
              outros.
            </h6>
          </div>
        </Card>
      </>
    </>
  );

  const minhaCota = (
    <>
      <>
        <Card
          title={<CardTitle>Qual o número de sua cota?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          {cronogramaEmp.current === 1 && origemApRef.current === 0 ? (
            <Form
              {...layout}
              name="numero-cota"
              disabled={bloqueadoEdicao.current}
              onValuesChange={(changedValues, allValues) =>
                numeroCotaChange(changedValues, allValues)
              }
              initialValues={formMinhaCotaOrigemProprietario}
              style={{
                marginLeft: "25px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              validateMessages={validarFormulario}
            >
              <Form.Item
                name={["numeroCota"]}
                label="Número da cota"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Select placeholder="Cota" labelInValue>
                  {cotasUsuario.map((cotaUsuario) => (
                    <Select.Option
                      key={cotaUsuario.id}
                      value={cotaUsuario.id}
                      label={cotaUsuario.numeroCota}
                    >
                      {cotaUsuario.numeroCota}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          ) : (
            <Form
              {...layout}
              name="numero-cota"
              disabled={bloqueadoEdicao.current}
              onValuesChange={(changedValues, allValues) =>
                numeroCotaOrigemProprietarioChange(changedValues, allValues)
              }
              initialValues={formMinhaCotaOrigemProprietario}
              style={{
                marginLeft: "25px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              validateMessages={validarFormulario}
            >
              <Form.Item
                name={["numeroCota"]}
                label="Número da cota"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Input placeholder="Número da cota" />
              </Form.Item>
            </Form>
          )}

          <div>
            <h6 style={{ fontSize: 15, marginTop: "20px", color: "red" }}>
              Atenção: Trata-se do número da cota e não da quantidade de
              cotas que possui.
            </h6>
          </div>
        </Card>
      </>
    </>
  );

  const minhaPrioridade = (
    <>
      <>
        <Card
          title={<CardTitle>Qual a sua prioridade ou número de Cota?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            {...layout}
            onValuesChange={(changedValues, allValues) =>
              prioridadeChange(changedValues, allValues)
            }
            initialValues={formPrioridade}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["prioridade"]}
              label="Prioridade"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input placeholder="Prioridade" />
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const minhaPrioridadeSemanasPorAno = (
    <>
      <>
        <Card
          title={<CardTitle>Quantas semanas tem direito ao ano?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            {...layout}
            name="semanas-ano"
            disabled={bloqueadoEdicao.current}
            onValuesChange={(changedValues, allValues) =>
              semanasPorAnoChange(changedValues, allValues)
            }
            initialValues={formSemanasPorAno}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["semanasPorAno"]}
              label="Semanas por ano"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input placeholder="Quantas semanas tem direito por ano" />
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const minhaPrioridadeDiaDaSemana = (
    <>
      <>
        <Card
          title={
            <CardTitle>Qual dia da semana começa seus períodos?</CardTitle>
          }
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            {...layout}
            name="diaDaSemana"
            onValuesChange={(changedValues, allValues) =>
              diaDaSemanaChange(changedValues, allValues)
            }
            initialValues={formDiaDaSemana}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["diaDaSemana"]}
              label="Dia Da Semana"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select placeholder="Selecione o dia da semana">
                {diasDaSemana.map((dias, index) => (
                  <Select.Option key={dias.id} value={dias.value}>
                    {dias.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const anunciarVenda = (
    <>
      <>
        <Card
          title={
            <CardTitle>
              Enquanto isso, gostaria de anunciar a venda de sua propriedade?
            </CardTitle>
          }
          bordered={true}
          type="inner"
          className="mobile"
        >
          <div>
            <h3>
              Vamos anunciar a venda de sua multipropriedade <br />
              no maior site do ramo da América latina?
              <br />
              É uma assinatura anual que custa o equivalente a só R$ 9,90
              mensais.
              <br />
              Imperdível! <br />Muito pouco dentro daquilo que pode ganhar.
              <br />
              
            </h3>
          </div>
          <Radio.Group
            onChange={anunciarChange}
            value={anunciar}
            className="custom-radio"
          >
            <Space direction="vertical">
              <Radio value={1}>Sim</Radio>
              <Radio value={2}>Não</Radio>
            </Space>
          </Radio.Group>
        </Card>
      </>
    </>
  );

  const MaisInfoAnuncioVenda = (
    <>
      <Card
        title={<CardTitle>Mais informações do anúncio</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          {...layout}
          form={maisInfoForm}
          name="maisInfo"
          onValuesChange={(changedValues, allValues) =>
            maisInfoChange(changedValues, allValues)
          }
          initialValues={formMaisInfo}
          style={{
            width: "100%",
            marginLeft: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["situacao"]}
            label="Situação da propriedade"
            rules={[{ required: true }]}
            className="formItems"
            style={{ width: "100%", marginBottom: "24px" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select placeholder="Situação da propriedade">
              {situacaoPropriedade.map((dias, index) => (
                <Select.Option key={dias.id} value={dias.value}>
                  {dias.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["valorVenda"]}
            label="Valor da Venda"
            rules={[{ required: true }]}
            className="formItems"
            style={{ width: "60%", marginBottom: "24px" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <InputNumber
              placeholder="Digite o valor da venda"
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name={["valorCondominio"]}
            label="Valor do Condomínio"
            rules={[{ required: true }]}
            className="formItems"
            style={{ width: "60%", marginBottom: "24px" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <InputNumber
              placeholder="Digite o valor do condomínio"
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>

          {minhaSituacao === "NAO_QUITADO" && (
            <Form.Item
              name={["saldoDevedor"]}
              label="Saldo devedor"
              rules={[{ required: true }]}
              className="formItems"
              style={{ width: "60%", marginBottom: "24px" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <InputNumber
                placeholder="Digite o Saldo devedor"
                formatter={(value) => {
                  if (value === undefined || value === null) return "";
                  return `R$ ${Number(value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                }}
                parser={(value) => {
                  if (!value) return "";
                  const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                  const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(
                    2
                  ); // Converte para decimal
                  return isNaN(Number(parsedValue)) ? "" : parsedValue;
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
        </Form>
      </Card>
    </>
  );

  const DesistenciaPagamento = (
    <Card
      title={<CardTitle> Multicotas</CardTitle>}
      bordered={true}
      type="inner"
      className="mobile"
    >
      <div>
        <h3>
          Sem problemas. <br />
          Caso mude de ideia, basta acessar "Minhas propriedades", <br />
          clicar em ações na propriedade que deseja anunciar e clicar em
          anunciar
        </h3>
      </div>
    </Card>
  );

  const adicionarPeriodosCronoEmpZero = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Informe os períodos que possui selecionando-os na coluna da esquerda
            e <br /> passando para as colunas da direita. Após clique em Salvar.
          </h3>
        </div>
      </Card>
    </>
  );
  const adicionarPeriodosCronoEmpDois = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>Informe os períodos que possui clicando no botão + Período.</h3>
        </div>
      </Card>
    </>
  );

  const definaPeriodoCronogramaEmpZeroEDois = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Pronto! <br />
            Agora vamos definir o que fazer com seus períodos <br /> clicando
            nos ícones <SettingsIcon color="primary" /> de cada semana...
          </h3>
        </div>
      </Card>
    </>
  );
  const definaPeriodoCronogramaEmpUm = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Pronto! <br />
            Agora vamos definir o que fazer com seus períodos <br /> clicando
            nos ícones <SettingsIcon color="primary" /> de cada semana...
            <br />
            Caso visualize períodos diferentes do que está <br />
            no cronograma, possívelmente, você cadastrou <br />o número da cota
            de forma equivocada. Se isso ocorrer, <br />
            favor entrar em contato conosco, <br />
            para ajudarmos a regularizar.
          </h3>
        </div>
      </Card>
    </>
  );
  const finalizacao = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Pronto! <br />
            <br />
            Situação:
            <br />A propriedade tem períodos? :{" "}
            <span
              style={{
                color: propriedadeTemPeriodos === "Sim" ? "green" : "red",
              }}
            >
              {propriedadeTemPeriodos}
            </span>
            <br />
            Os períodos estão definidos? :{" "}
            <span
              style={{
                color:
                  propriedadeTemPeriodosDefinidos === "Sim" ? "green" : "red",
              }}
            >
              {propriedadeTemPeriodosDefinidos}
            </span>
            <br />
            Se houver pagamentos, estão regularizados? :{" "}
            <span
              style={{
                color:
                  pagamentoRegularizado === "Não" ||
                  pagamentoRegularizado === "Não. Aguardando confirmação"
                    ? "red"
                    : "green",
              }}
            >
              {pagamentoRegularizado}
            </span>
            <br />
            Se houver representantes, estão regularizados? :{" "}
            <span
              style={{
                color: representanteRegularizado === "Não" ? "red" : "green",
              }}
            >
              {representanteRegularizado}
            </span>
            <br />A propriedade já foi autenticada? :{" "}
            <span
              style={{
                color: propriedadeAutenticada === "Sim" ? "green" : "red",
              }}
            >
              {propriedadeAutenticada}
            </span>{" "}
           
            <br />
            Você está anunciando a venda de sua propriedade? :{" "}
            <span
              style={{
                color: anuncioPropriedade === true ? "green" : "red",
              }}
            >
              {anuncioPropriedade === true ? (
                <>
                  Sim{" "}
                  <button
                    style={{
                      backgroundColor: "rgb(0, 54, 68)",
                      color: "white",
                      border: "none",
                      padding: "5px 15px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "16px",
                      transition: "background-color 0.3s",
                    }}
                    onClick={() =>
                      (window.location.href = `https://vendas.multicotas.com.br/detalhes.html?id=${pCotaUsuarioId.pCotaUsuarioId}`)
                    }
                  >
                    Ver anúncio
                  </button>
                </>
              ) : (
                "Não"
              )}
            </span>{" "}
            <br />
            <br />
            <br />
            <div style={{ whiteSpace: "pre-wrap" }}>{textoFinalizacao}</div>
          </h3>
        </div>
      </Card>
    </>
  );
  

  const handleStepClick = async (index: any) => {
    const status = await buscarStatusCTU(cotaUsuarioId);
    changing.current = false;

    switch (index) {
      case 0:
        if (status !== "AGUARDANDO_CADASTRO") {
          setBloquearBotaoProximo(false);
        }

        setActiveStep(0);
        setRenderApSteps(0);
        setRenderEmpSteps(0);
        break;
      case 1:
        if (pCotaUsuarioId.pCotaUsuarioId === 0) {
          error("Favor terminar de informar os dados do cadastro inicial");
        } else {
          switch (status) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
              error("Favor terminar de informar os dados do cadastro inicial");
              buscarDadosCotaUsuario();

              break;
            case "AGUARDANDO_TITULARIDADE":
              setBloquearBotaoProximo(true);
              setActiveStep(1);
              setRenderProprietario(0);
              break;

            default:
              setBloquearBotaoProximo(false);
              setActiveStep(1);
              setRenderProprietario(0);
              break;
          }
        }

        break;
      case 2:
        if (pCotaUsuarioId.pCotaUsuarioId === 0) {
          error("Favor terminar de informar os dados do cadastro inicial");
        } else {
          switch (status) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
              error("Favor terminar de informar os dados do cadastro inicial");
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_COMPROVANTE":
              setBloquearBotaoProximo(true);
              error(
                "Favor terminar de informar os dados de validação de proprietário."
              );
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_TITULARIDADE":
              error(
                "Favor terminar de informar os dados de validação de proprietário."
              );
              buscarDadosCotaUsuario();

              break;

            default:
              setBloquearBotaoProximo(false);
              switch (cronogramaEmp.current) {
                case 0:
                  setActiveStep(2);
                  setRenderCotaSteps(0);
                  setRenderPrioridadeSteps(1);
                  break;
                case 1:
                  setActiveStep(2);
                  setRenderCotaSteps(1);
                  setRenderPrioridadeSteps(0);
                  if (
                    formMinhaCotaOrigemProprietario.numeroCota === undefined ||
                    formMinhaCotaOrigemProprietario.numeroCota === 0
                  ) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }
                  break;
                case 2:
                  setActiveStep(2);
                  setRenderCotaSteps(0);
                  setRenderPrioridadeSteps(0);
                  if (cronogramaFixoOuPrioridade === 0) {
                    setBloquearBotaoProximo(true);
                  } else {
                    setBloquearBotaoProximo(false);
                  }
                  break;
              }
              break;
          }
        }

        break;
      case 3:
        if (pCotaUsuarioId.pCotaUsuarioId === 0) {
          error("Favor terminar de informar os dados do cadastro inicial");
        } else {
          switch (status) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
              error("Favor terminar de informar os dados do cadastro inicial");
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_TITULARIDADE":
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_COMPROVANTE":
              error(
                "Favor terminar de informar os dados de validação de proprietário."
              );
              buscarDadosCotaUsuario();
              break;

            case "AGUARDANDO_COTA":
              error("Favor terminar de informar os dados da propriedade.");
              buscarDadosCotaUsuario();
              break;
            default:
              telaDePagamento();
              break;
          }
        }

        break;
      case 4:
        if (pCotaUsuarioId.pCotaUsuarioId === 0) {
          error("Favor terminar de informar os dados do cadastro inicial");
        } else {
          switch (status) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
              error("Favor terminar de informar os dados do cadastro inicial");
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_TITULARIDADE":
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_COMPROVANTE":
              error(
                "Favor terminar de informar os dados de validação de proprietário."
              );
              buscarDadosCotaUsuario();
              break;

            case "AGUARDANDO_COTA":
              error("Favor terminar de informar os dados da propriedade.");
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_DEFINICAO_ANUNCIO":
              error(
                "Favor informar se deseja anunciar a venda de sua propriedade."
              );
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_MAISINFO_ANUNCIO":
              error("Favor informar os dados do anúncio.");
              buscarDadosCotaUsuario();
              break;
            case "AGUARDANDO_PERIODOS":
              switch (cronogramaEmp.current) {
                case 0:
                  setActiveStep(4);
                  setRenderAdicionarPeriodo(1);
                  break;

                case 2:
                  setActiveStep(4);
                  setRenderAdicionarPeriodo(2);
                  break;
              }

              break;
            case "AGUARDANDO_DEFINICAO_PERIODOS":
              switch (cronogramaEmp.current) {
                case 0:
                  break;
                case 2:
                  setActiveStep(5);
                  setRenderAdicionarPeriodo(4);
                  break;
                case 1:
                  setActiveStep(5);
                  setRenderAdicionarPeriodo(3);

                  break;
              }

              break;
            default:
              const periodosDefinidos =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidos) {
                setActiveStep(6);
              } else {
                const temPeriodos = await verificarSeTemPeriodoUsuario(
                  cotaUsuarioId
                );
                if (temPeriodos) {
                  setActiveStep(5);
                  setRenderAdicionarPeriodo(3);
                } else {
                  setActiveStep(4);
                  setRenderAdicionarPeriodo(1);
                }
              }
              break;
          }
        }

        break;
    }
  };

  //-------------------- Componente Principal -----------------------------\\
  return (
    <Flex
      gap="middle"
      vertical
      align="center"
      justify="center"
      style={{
        flex: "display",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {isLoading.current ? (
        <Skeleton active />
      ) : (
        <div>
          {contextHolder}
          <Row
            style={{
              flex: "display",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Col span={3}></Col>
            <Col>
              <StyledTitle>Cadastro de propriedade</StyledTitle>
            </Col>
            <Col span={3}></Col>
          </Row>

          <Divider />

          <Row>
            <Flex gap="large" vertical align="center" justify="center">
              <Stepper
                activeStep={activeStep}
                sx={{
                  margin: {
                    xs: "0 0px 0 0", // margem esquerda para dispositivos móveis
                    sm: "0 auto", // centraliza para dispositivos maiores
                  },
                  "& .MuiStepLabel-label": {
                    fontSize: {
                      xs: "0.4rem", // tamanho da fonte para dispositivos móveis
                      sm: "1rem", // tamanho da fonte para dispositivos maiores
                    },
                  },
                }}
              >
                {/* Tem como função mapear os passos do array steps */}
                {steps.map((label, index) => {
                  /* stepProps indica se o passo foi concluído */
                  const stepProps: { completed?: boolean } = {};
                  const labelProps: {
                    optional?: React.ReactNode;
                  } = {};
                  /* Cria o componente para cada step do array*/
                  return (
                    <Step key={label}>
                      <StepLabel onClick={() => handleStepClick(index)}>
                        {label}
                      </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {/* Condicional de renderização */}

              {/* Renderiza condicionalmente o conteúdo dos passos (primeiroPasso, segundoPasso, terceiroPasso, quartoPasso) baseado no estado activeStep e isLoading.*/}
              <>
                <Typography
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {/* Renderização do Passo 1 */}
                  {activeStep === 0 && !isLoading.current && (
                    <>
                      {renderApSteps === 0 &&
                        renderEmpSteps === 0 &&
                        selecionarEmpreendimento}

                      {/* Quando Encontrado o empreeendimento, vai para tela especificações do apartamento */}
                      {renderApSteps === 1 && especificacoesApto}

                      {renderApSteps === 3 && maisInfoApartamento}

                      {/* Quando Nao Encontrado o empreeendimento, vai para a tela de cadastro de empreendiemento */}
                      {renderEmpSteps === 1 && cadastrarEmpreendimentoMensagem}

                      {/* Tela de cadastro de empreendiemento */}
                      {renderEmpSteps === 2 && cadastrarEmpreendimentos}

                      {/* Tela de cadastro de Apartamento */}
                      {renderEmpSteps === 3 && cadastrarApartamento}
                    </>
                  )}

                  {/* Renderização do Passo 2 */}
                  {activeStep === 1 && !isLoading.current && (
                    <>
                      {renderProprietario === 0 && titularidadePropriedade}

                      {/* Titularidade em nome de outra pessoa */}
                      {renderProprietario === 1 &&
                        titularidadeOutraPessoaMensagem}
                      {renderProprietario === 2 && atualizarCadastroOutraPessoa}
                      {renderProprietario === 3 &&
                        atualizarCadastroProprietario}
                      {renderProprietario === 4 && comprovantePropriedade}
                    </>
                  )}

                  {/* Renderização do Passo 3 */}
                  {activeStep === 2 && !isLoading.current && (
                    <>
                      {/* Verifica se o apartamento e o empreendimento são do sistema, se forem pula direto para o anuncio. */}
                      {renderCotaSteps === 0 &&
                        renderPrioridadeSteps === 0 &&
                        cronogramaFixoOuPrioridadeComponente}

                      {renderCotaSteps === 1 &&
                        renderPrioridadeSteps === 0 &&
                        minhaCota}

                      {renderCotaSteps === 0 &&
                        renderPrioridadeSteps === 1 &&
                        minhaPrioridade}

                      {/* Se selecionado Prioridade */}
                      {renderPrioridadeSteps === 2 &&
                        minhaPrioridadeSemanasPorAno}
                      {renderPrioridadeSteps === 3 &&
                        minhaPrioridadeDiaDaSemana}
                    </>
                  )}

                  {activeStep === 3 && !isLoading.current && (
                    <>
                      {/* Gostaria de anunciar?*/}
                      {renderPagamentoSteps === 1 && anunciarVenda}
                      {/* Mais informações da propriedade*/}
                      {renderPagamentoSteps === 2 && MaisInfoAnuncioVenda}
                      {/* Mensagem pós desistencia de pagamento*/}
                      {renderPagamentoSteps === 3 && DesistenciaPagamento}
                    </>
                  )}
                  {activeStep === 4 && !isLoading.current && (
                    <>
                      {/* Adicionar períodos para cronograma zero ou seja por prioridade*/}
                      {renderAdicionarPeriodo === 1 &&
                        adicionarPeriodosCronoEmpZero}
                      {/* Adicionar períodos para empreendimento criado pelo usuário*/}
                      {renderAdicionarPeriodo === 2 &&
                        adicionarPeriodosCronoEmpDois}
                    </>
                  )}
                  {activeStep === 5 && !isLoading.current && (
                    <>
                      {/* Empreendimento ja existente e houver cronograma */}
                      {renderAdicionarPeriodo === 3 &&
                        definaPeriodoCronogramaEmpUm}
                      {/* Emprendimento do usuario ou Empreendimento do sistema e prioridade */}
                      {renderAdicionarPeriodo === 4 &&
                        definaPeriodoCronogramaEmpZeroEDois}
                    </>
                  )}
                  {activeStep === 6 && !isLoading.current && (
                    <>
                      {/* Tela de finalização mas sem anuncio */}
                      {finalizacao}
                    </>
                  )}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    pt: 2,
                    marginBottom: 10,
                  }}
                >
                  <ContainerButton>
                    <Button
                      disabled={
                        activeStep === 0 &&
                        renderApSteps === 0 &&
                        renderEmpSteps === 0
                      }
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Voltar
                    </Button>
                  </ContainerButton>
                  <Box sx={{ flex: "1 1 auto" }} />

                  <ContainerButton>
                    <Button
                      disabled={bloquearBotaoProximo}
                      onClick={handleNext}
                    >
                      {activeStep === 6 ? "Finalizar" : "Próximo"}
                    </Button>
                  </ContainerButton>
                </Box>
              </>
            </Flex>
          </Row>
        </div>
      )}
    </Flex>
  );
}
